import calculateUtil from '../../../static/js/calculateUtil'
import objectUtil from '../../../static/js/objectUtil'
import lodashUtils from '../../../static/js/lodashUtils'
import * as scanUtils from '../../../static/js/scanUtils'

const setValue = objectUtil.setValueByPath
const getValue = objectUtil.getValueByPath
// {
//   code: != 200,
//   msg: ...,
//   errors: [],
//   data: ...
// }
class Response {
  constructor(init = {}) {
    ;(this.code = init.code || 200),
      (this.msg = init.code || '成功'),
      (this.errors = init.errors || null),
      (this.data = init.data || null)
  }
}

export default {
  props: {
    stockDialogZIndex: {
      type: Number,
      default: 5000,
    },
    store: Object,
    importGoodsAndBatchByTrackUrl: String,
    importGoodsAndBatchByTrackParam: {
      type: Object,
      default: () => ({}),
    },
    importInventoryUrl: String,
    importInventoryParam: {
      type: Object,
      default: () => ({}),
    },
  },
  methods: {
    /** @name 找出所有商品相同的行，如果存在ifParent表示明细中存在parent，主行和从行的parent一样 */
    seachRows(ifParent, self = this) {
      let arr = new Map()
      const tableData = self.tableData
      tableData.map((item, index) => {
        let one =
          this.scanFormData[this.dataGoodsInfoKey].id &&
          item[this.dataGoodsInfoKey].id === this.scanFormData[this.dataGoodsInfoKey].id
        let two =
          !this.scanFormData[this.dataGoodsInfoKey].id &&
          this.scanFormData[this.dataGoodsKeepingKey].epc &&
          item[this.dataGoodsKeepingKey].epc === this.scanFormData[this.dataGoodsKeepingKey].epc

        if (one || two || this.disabledEpcQuery) {
          if (ifParent) {
            if (!item.parent) {
              console.error('没有parent')
            }
            let now = arr.get(item.parent)
            if (now) {
              now.push({ index, item })
            } else {
              arr.set(item.parent, [{ index, item }])
            }
          } else {
            arr.set(index, item)
          }
        }
      })
      return arr
    },
    /** @name 找出主行 */
    seachMaster(arr, key) {
      return arr.find((item) => getValue(item, key ? `${key}.master` : 'master'))
    },
    /**
     * @name 查找所属的主行数据，并添加至数组开头
     * @param {*} row 待处理的数据
     *
     */
    searchMasterToFirst(row, self = this) {
      // 未开启单条模式，则忽略此函数的处理逻辑；开启单条模式，则根据 row.parent、row._ID 是否有值确定是否忽略此函数的处理逻辑
      if (!self.isSingle || !row?.parent || !row?._ID) return
      // 过滤掉 taskData 中的 row
      const list = self.taskData.filter((t) => t._ID !== row._ID)
      // 任务模式且 model 配置在数组 modes 中的，则只显示当前扫码的任务
      const modes = [
        'import',
        'matchAndImportByItemsForReunion',
        'matchAndImportForStockOfReunion',
        'matchAndImportForStockNoParent',
      ]
      if (self.isSingle && modes.includes(self.model)) {
        self.taskData = [row, ...list]
      } else {
        // 查找相同 parent 的数据（不包含: row）
        let arr = self.tableData.filter((t) => t.parent === row.parent && t._ID !== row._ID)
        // 数据交换，如果 arr 中的数据在 taskData 中存在，则交换为 taskData 的数据，否则交换为 arr 的数据
        arr = arr.reduce((prev, cur) => {
          const fIndex = list.findIndex((t) => t._ID === cur._ID)

          prev.push(fIndex > -1 ? list[fIndex] : cur)
          if (fIndex > -1) list.splice(fIndex, 1) // 删除 taskData 中在原 arr 中存在的数据

          return prev
        }, [])

        self.taskData = [row, ...arr, ...list]
      }
      // row 不是主行
      if (!row?.master) {
        // 查找 taskData 的主行
        const mIndex = self.taskData.findIndex((t) => t.master)
        self.taskData = self.rowToFrist(self.taskData, mIndex)
      }
      console.log(self.model, self.formData.items, self.taskData, self.tableData)
    },
    /** @name 校验明细行中是否有相同的行 */
    searchRowIsSame(
      scanFormData,
      items,
      checkArr = [
        `${this.dataGoodsInfoKey}.id`,
        `${this.dataGoodsKeepingKey}.batchNumber`,
        `${this.dataGoodsKeepingKey}.serialNumber`,
      ]
    ) {
      for (const item of items) {
        const isSame = scanUtils.checkGoodAndBatchIsEq(item, scanFormData, checkArr)
        if (isSame) return true
      }

      return false
    },
    /** @name 校验绑定rfid条码是否已使用 */
    checkRfidIsReapt(task, ids = []) {
      let isReapt = false
      const idsMap = new Map()
      ids.forEach((id) => {
        idsMap.set(id, true)
      })

      main: for (let [, val] of task) {
        child: for (let item of val) {
          const epcs = item.item?.epcs
          if (!epcs?.length) continue child
          for (const epc of epcs) {
            if (epc && idsMap.get(epc)) {
              isReapt = true
              break main
            }
          }
        }
      }

      return isReapt
    },
    /** @name 校验所扫项在行中是否为空 */
    checkRowValIsNull(row, scanData) {
      for (let [key] of scanData) {
        if (getValue(row, `${this.dataGoodsKeepingKey}.${key}`)) {
          return false
        }
      }
      return true
    },
    /** @name 校验所扫项在行中是否为空 */
    checkRowValIsNullforKeys(row, keys = ['batchNumber', 'periodBegin']) {
      const ifSerial = scanUtils.ifSerial(row, `${this.dataGoodsInfoKey}.keepingSerial`)
      console.log('ifSerial: ', ifSerial)
      if (ifSerial) keys.push('serialNumber')
      for (let key of keys) {
        if (keys.includes(key) && getValue(row, `${this.dataGoodsKeepingKey}.${key}`)) {
          return false
        }
      }
      return true
    },
    /** @name 校验所扫项在行中是否相等 */
    checkRowValIsEq(row, scanData, keys = ['batchNumber', 'serialNumber', 'periodBegin']) {
      // #35947，将厂家原始条码排除到匹配明细之外
      keys.push('originBarCode', 'originBarCodeDisplay')
      for (let key of keys) {
        let itemVal =
          key in this.scanFormData[this.dataGoodsKeepingKey]
            ? getValue(this.scanFormData, `${this.dataGoodsKeepingKey}.${key}`)
            : scanData.get(key)
        let rowVal = getValue(row, `${this.dataGoodsKeepingKey}.${key}`)
        if (lodashUtils.isNone(itemVal)) itemVal = null
        if (lodashUtils.isNone(rowVal)) rowVal = null

        if (rowVal !== itemVal) return false
      }

      return true
    },
    /** @name 校验所选项中批号信息是否与任务中匹配 */
    checkRowAndSelectBatchIsEq(
      row,
      goodsKeeping,
      // 去掉有效期至、失效日期、厂家原始条码的匹配
      excludes = ['periodEnd', 'periodExpire']
    ) {
      // #35947，将厂家原始条码排除到匹配明细之外
      excludes.push('originBarCode', 'originBarCodeDisplay')
      for (let key in goodsKeeping) {
        if (
          !excludes.includes(key) &&
          typeof goodsKeeping[key] !== 'object' &&
          getValue(row, `${this.dataGoodsKeepingKey}.${key}`) &&
          getValue(row, `${this.dataGoodsKeepingKey}.${key}`) !== goodsKeeping[key]
        ) {
          return false
        }
      }
      return true
    },
    /**
     * 校验扫码数量是否已超出待处理数量 eg. amount > plan
     *
     * @description status=true 通过，否则不通过
     * @param {*} row 当前行数据
     * @param {boolean} [ifEdit=false] 是否是编辑状态
     * @param {*} [vue] 上下文
     * @returns {*} result 校验结果 eg. { status: false, message: '操作失败，超出上游单据数量范围' }
     */
    checkTotalAmount(row, ifEdit = false, vue) {
      const ctx = vue || this
      // 未配置 treeRes 说明未拆行，则无需此判断
      if (!ctx.treeRes) return { status: true }

      let task = this.seachRows(true, vue)
      const result = {}
      for (let [, val] of task) {
        let amoutAll = this.amountTotal(val, `item.${this.dataAmountKey}`)
        let nowAmount = calculateUtil.numberAdd(amoutAll, this.scanFormData[this.dataAmountKey])
        // 如果是编辑，则减掉编辑的行数据 row.amount
        if (ifEdit && row?.amount) {
          nowAmount = calculateUtil.numberSub(nowAmount, row.amount)
        }
        let masterRow = this.seachMaster(val, 'item')
        // 所有主从行的数量之和（包括此次扫码的数量） 大于计划数量
        result.status = nowAmount <= masterRow.item[this.dataPendingKey]
        if (!result.status) break
      }
      if (!result.status) {
        result.message = '操作失败，超出上游单据数量范围'
      } else {
        result.message = null // message 不为 null 会显示提示信息。详见：ifEdit 调用的地方
      }

      return result
    },
    /** @name 从库存选择时校验库存id是否相同 */
    checkBatchIsEq(row, scanFormData) {
      let key =
        this.dataGoodsKeepingKey === 'goodsStore' ? 'goodsStore.storageItemId' : 'storageItem.id'
      return getValue(row, key) === getValue(scanFormData, key)
    },
    /** @name 从库存选择时校验商品id是否相同 */
    checkGoodsIsEq(row, scanFormData) {
      let key = `${this.dataGoodsInfoKey}.id`
      return getValue(row, key) === getValue(scanFormData, key)
    },
    /**
     * @name 判断keys中的字段是否相等是否相同
     * eqNone = true 表示为空时字段相等
     */
    checkGoodAndBatchIsEq(row, scanFormData, keys = [], propName = '', eqNone = false) {
      return !keys.some(
        (key) =>
          (!eqNone && lodashUtils.isNone(getValue(scanFormData, key))) ||
          getValue(scanFormData, key) !== getValue(row, propName ? propName : key)
      )
    },
    /** @name 校验验收结论，是否相同 */
    checkAcceptStatus(row, scanFormData) {
      return (
        !getValue(scanFormData, `${this.getAcceptStatusKey()}.code`) ||
        getValue(scanFormData, `${this.getAcceptStatusKey()}.code`) ===
          getValue(row, `${this.getAcceptStatusKey()}.code`)
      )
    },
    /** @name 校验货位，是否相同 */
    checkLocationOfId(row, scanFormData) {
      return (
        !getValue(scanFormData, `location.id`) ||
        getValue(scanFormData, `location.id`) === getValue(row, `location.id`)
      )
    },
    /** @name 校验库存id相同时，商品id是否一致，如果不一致则报错 */
    checkStorageItemIdAndGoodsId(row, scanFormData) {
      // 库存 id 相同时
      if (this.checkBatchIsEq(row, scanFormData) && !this.checkGoodsIsEq(row, scanFormData)) {
        const scanGoodsDetail = scanFormData[this.dataGoodsInfoKey]
        const stoargeGoodsDetail = row[this.dataGoodsInfoKey]

        return `存在多条相同库存信息的商品${scanGoodsDetail.name}（${scanGoodsDetail.code}）和 ${stoargeGoodsDetail.name}（${stoargeGoodsDetail.code}）`
      }

      return false
    },
    /** @name 检查开启序列号管理的商品数量是否大于1 */
    checkSerialAmount(row, scanFormData) {
      const ifSerial = scanUtils.ifSerial(row, `${this.dataGoodsInfoKey}.keepingSerial`)
      const serialNumber = getValue(scanFormData, `${this.dataGoodsKeepingKey}.serialNumber`)
      const isGtAmount = row[this.dataAmountKey] > 1 || scanFormData?.[this.dataAmountKey] > 1
      console.log('检查开启序列号管理的商品数量是否大于1 row: ', row)
      console.log('scanFormData: ', scanFormData)
      console.log('ifSerial: ', ifSerial)
      console.log('serialNumber: ', serialNumber)
      console.log('isGtAmount: ', isGtAmount)

      if (ifSerial && serialNumber && isGtAmount) {
        return '该商品已开启序列号管理，数量不可大于 1'
      }
      return false
    },
    /** @name 校验商品是否开启epc管理和策略是否为手动 */
    async checkRfid(self) {
      return new Promise((resolve) => {
        // 获取策略：自定义序列号生成和赋码模式的值
        const strategy = objectUtil.getValueByPath(
          this.$store,
          'state.strategy.strategy.WMS_CUSTOM_SERIAL_GENERATE_AND_ASSIGN_MODE'
        )
        // 系统策略【自定义序列号生成和赋码模式】是否设置为“手动”
        const isManaul = strategy === 'MANAUL'
        // 是否已开启【自定义序列号管理】
        const ifEpc =
          this.goodsInfo?.keepingCustomSerial ||
          this.scanFormData[this.dataGoodsInfoKey]?.keepingCustomSerial
        // 是否已开启【RFID管理】
        const ifRfid =
          this.goodsInfo?.keepingRfidSerial ||
          this.scanFormData[this.dataGoodsInfoKey]?.keepingRfidSerial

        if (!ifEpc || !ifRfid || !isManaul) {
          resolve(false)
          return
        }

        let isOpenRfid = false
        // 查找上表的任务
        let task = this.seachRows(true, self)
        for (let [, val] of task) {
          for (let item of val) {
            const checkArr = this.setCheckArr()
            const ifSerial = scanUtils.ifSerial(
              this.scanFormData,
              `${this.dataGoodsInfoKey}.keepingSerial`
            )
            if (ifSerial) checkArr.push(`${this.dataGoodsKeepingKey}.serialNumber`)

            if (this.checkGoodAndBatchIsEq(item.item, this.scanFormData, checkArr)) {
              isOpenRfid = true
              break
            }
          }
        }

        const ifEdit = this.ifEdit(this.scanFormData, false, true, self)
        if (isOpenRfid && !ifEdit) {
          self.openRfidModal(this.scanFormData[this.dataAmountKey])
          self.resolveRfidBindModel = resolve
        } else {
          resolve(false) // 不绑定RFID条码，则走原来的 modelCheckoutAmount 逻辑
        }
      })
    },
    //检查序列号是否唯一
    checkSerialNumberOnly(serialNumber, tableData) {
      return tableData.findIndex(
        (item) => getValue(item, `${this.dataGoodsKeepingKey}.serialNumber`) === serialNumber
      )
    },
    /** @name 校验重复商品id+批号+原厂序列号（已开启序列号管理）+供应商（灵科） */
    validRepeatForSerial(self) {
      const isLink = this.dataGoodsKeepingKey === 'goodsStore'
      const dataGoodsInfoKey = this.dataGoodsInfoKey
      const dataGoodsKeepingKey = this.dataGoodsKeepingKey
      const tableData = self.tableData
      const scanFormData = this.scanFormData
      const goodsInfo = scanFormData[dataGoodsInfoKey]
      const goodsKeeping = scanFormData[dataGoodsKeepingKey]
      // 是否开启原厂序列号管理
      const keepingSerial = goodsInfo?.keepingSerial
      // 无数据显示文本
      const NO_DATA = '-'
      // 错误提示文本
      let errorMessage = ''
      // 是否重复
      let isRepeat = false

      // Bug#32046，如果是 this.model === 'importGoodsAndBatch' 和处于编辑状态则忽略重复校验
      const ifEdit = this.ifEdit(this.scanFormData, true, false, self, true)
      if (this.model === 'importGoodsAndBatch' && !ifEdit) {
        for (const cur of tableData) {
          const curInfo = {
            id: cur[dataGoodsInfoKey]?.id,
            [this.dataAmountKey]: cur?.[this.dataAmountKey],
            serialNumber: cur[dataGoodsKeepingKey]?.serialNumber,
            batchNumber: cur[dataGoodsKeepingKey]?.batchNumber,
            targetId: cur[dataGoodsInfoKey]?.target?.id,
          }
          // 商品名添加至错误提示文本中
          errorMessage = goodsInfo?.name ?? NO_DATA
          // 修复Bug#31860，初步重复判断, Bug#31930，先判断是否是编辑状态，看是否解决问题，且未引发其他问题
          isRepeat =
            this.scanStatus !== 'update' &&
            curInfo[this.dataAmountKey] > 0 &&
            goodsInfo?.id === curInfo.id

          // 批号是否有值
          if (curInfo.batchNumber && goodsKeeping?.batchNumber) {
            errorMessage += `，批号：${goodsKeeping?.batchNumber ?? NO_DATA}`
            isRepeat = isRepeat && goodsKeeping?.batchNumber === curInfo.batchNumber
          }
          // 原厂序列号是否已开启
          if (keepingSerial && goodsKeeping?.serialNumber) {
            errorMessage += `，序列号：${goodsKeeping?.serialNumber ?? NO_DATA}`
            isRepeat = isRepeat && goodsKeeping?.serialNumber === curInfo.serialNumber
          }
          // 灵科
          if (isLink) {
            // 供应商是否有值
            if (curInfo.targetId && goodsInfo?.target?.id) {
              errorMessage += `，供应商：${goodsInfo?.target?.name ?? NO_DATA}`
              isRepeat = isRepeat && goodsInfo?.target?.id === curInfo.targetId
            }
          }

          if (isRepeat) break // 发现重复即结束循环
        }
      }

      // 如果重复，则返回警告信息
      if (isRepeat) return `${errorMessage}，重复验收或添加！`

      return null
    },
    /** @name 校验是否开启序列号或自定义序列号管理 */
    // #6553
    ifSerial(scanFormData) {
      return scanFormData.keepingSerial
    },
    /**
     * @name 判断是否是编辑
     *
     * @description 如果_ID相同则是编辑，且需要根据参数的值确定是否校验数量
     * @param {*} scanFormData 扫码区表单数据
     * @param {*} [disabledCheckAmount=false] 是否禁止校验已扫数量 > 待处理数量 Tip: 无源的情况无需校验
     * @param {*} [onlyUpdateAmount=false] 仅更新数量，适用于匹配
     * @param {vue} [_self] 实例 this
     * @param {function|boolean} [fnCallback] 回调函数或是否开启修改，传入此参数为function或true，则不会在此方法内更新 tableData 和 taskData
     * @returns {Boolean}
     */
    ifEdit(scanFormData, disabledCheckAmount = false, onlyUpdateAmount = false, _self, fnCallback) {
      const self = _self || this
      // let m = new Map()
      let index = -1
      // 查找所有主行 和 _ID 相同的索引
      self.tableData.forEach((item, nIndex) => {
        if (item._ID && item._ID === scanFormData._ID) index = nIndex
        // if (item.master && item?.parent) m.set(item.parent, item)
      })

      console.log(index, 'index')
      if (index !== -1) {
        // 有源：判断已扫数量是否小于待处理数量，如果大于则给出提示
        let row = self.tableData[index]

        // #35171，查找上表数据找到相同主行的行数据
        let task = this.seachRows(true, self)
        const m = new Map()
        for (const [, val] of task) {
          const master = this.seachMaster(val, 'item')
          for (const v of val) {
            m.set(getValue(v, 'item._ID'), getValue(master, 'item'))
          }
        }

        if (!disabledCheckAmount) {
          // 开启序列号管理后，校验序列号数量不可大于 1
          const msg = this.checkSerialAmount(row, scanFormData)
          if (msg) return { message: msg }
          // #35171，查找当前行的主行的计划数量
          const planRow = getValue(m.get(row._ID), `${this.dataPendingKey}`)
          // 校验行数据的待处理数量是否小于扫码数量
          if (parent && scanFormData[this.dataAmountKey] > planRow) {
            return { message: '操作失败，超出上游单据数量范围' }
          }
        }

        // 灵科 - 待处理-来自收货通知单，amount 的值不相等时，调反算
        if (scanFormData[this.dataAmountKey] !== row[this.dataAmountKey]) {
          this.store?.dispatch?.('orderBackCountUtil', 'amountBack', scanFormData, {})
        }

        if (fnCallback) {
          typeof fnCallback === 'function' && fnCallback({ index, onlyUpdateAmount })
        } else {
          if (onlyUpdateAmount) {
            self.tableData[index][`${this.dataAmountKey}`] = scanFormData[`${this.dataAmountKey}`]
            if (this.dataAmountKey === 'amount') {
              self.tableData[index].amountDisplay = scanFormData.amountDisplay
            }
          } else {
            self.tableData[index] = scanFormData
          }
          self.tableData = this.rowToFrist(self.tableData, index)
          // 同步更新 taskData
          this.syncUpdateTaskData(self.tableData[0], false, self)
          this.setTreeExpand(self)
        }

        return true
      }
      return false
    },
    /** @name 计算总和 */
    amountTotal(arr, key) {
      const temp = arr.reduce((acc, cur) => calculateUtil.numberAdd(acc, getValue(cur, key)), 0)
      return temp
    },
    /**
     * @name 同步更新taskData
     *
     * @param {*} row 待同步的数据
     * @param {boolean} [insert=false] 是否是新增模式
     * @returns
     */
    syncUpdateTaskData(row = null, insert = false, self = this) {
      // 新增
      if (insert) {
        self.taskData = [row, ...self.taskData]
        // 查找主行并添加至开头
        self.searchMasterToFirst(row, self)
        return
      }
      // 更新
      if (row?._ID) {
        const nIndex = self.taskData.findIndex((task) => task._ID === row?._ID)
        if (nIndex > -1) {
          self.taskData = self.rowToFrist(self.taskData, nIndex)
          self.taskData[0] = row
        } else {
          self.taskData = [row, ...self.taskData]
        }

        // 查找主行并添加至开头
        self.searchMasterToFirst(row, self)
        return
      }

      // 执行到这里说明出错啦
      throw new Error('同步更新 taskData 的数据异常')
    },
    /**
     * @name 添加或更新厂家原始条码
     * @description 如果扫码获取到厂家原始条码，则将 originBarCode 和 originBarCodeDisplay 赋值到任务明细中
     *
     * @param {any} row 行数据
     *
     */
    setOriginBarCode(row) {
      // lqn-39629 入库通知单，验收单，扫码入库，自动匹配注册证的时候，后台返回了受托生产企业，结果扫码没有回写到列表，需要回写到列表
      this.setEntrustedManufacturer(row)

      console.log('setOriginBarCode row: ', row)
      // 判断明细行数据是否已录入过厂家原始条码
      if (getValue(row, `${this.dataGoodsKeepingKey}.originBarCode`)) {
        console.log(
          '已录入过厂家原始条码',
          getValue(row, `${this.dataGoodsKeepingKey}.originBarCode`),
          row
        )
        return
      }

      const originBarCode = getValue(this.scanFormData, `${this.dataGoodsKeepingKey}.originBarCode`)
      const originBarCodeDisplay = getValue(
        this.scanFormData,
        `${this.dataGoodsKeepingKey}.originBarCodeDisplay`
      )
      if (originBarCode) setValue(row, `${this.dataGoodsKeepingKey}.originBarCode`, originBarCode)
      if (originBarCodeDisplay) {
        setValue(row, `${this.dataGoodsKeepingKey}.originBarCodeDisplay`, originBarCodeDisplay)
      }

      // const keys = ['originBarCode', 'originBarCodeDisplay']
      // for (const key of keys) {
      //   // 明细行数据中已录入过厂家原始条码的就忽略
      //   if (getValue(row, `${this.dataGoodsKeepingKey}.originBarCode`)) {
      //     console.log('已录入过厂家原始条码', row)
      //     continue
      //   }

      //   // 明细行数据中未录入过厂家原始条码，则只要扫码扫到厂家原始条码信息就录入
      //   const originBarCode = getValue(this.scanFormData, `${this.dataGoodsKeepingKey}.${key}`)
      //   if (originBarCode) setValue(row, `${this.dataGoodsKeepingKey}.${key}`, originBarCode)
      //   console.log('已扫到厂家原始条码: ', originBarCode)
      // }
    },
    // 设置受托生产企业entrustedManufacturer 字段在 生产许可证certification字段中， 要保存在 attrs.valueEnum.entrustedManufacturer 中
    setEntrustedManufacturer(row) {
      // 明细行数据中已录入过厂家原始条码的就忽略
      const entrustedManufacturer = getValue(
        this.scanFormData,
        `${this.dataGoodsKeepingKey}.certification.entrustedManufacturer`
      )
      if (entrustedManufacturer) {
        setValue(row, `attrs.valueEnum.entrustedManufacturer`, entrustedManufacturer)
        console.log('设置受托生产企业entrustedManufacturer', row)
      }
    },
    /** @name 在选择的情况下，如果扫码信息中没有的值，根据选中的数据填入 */
    setScanData(scanData, scanFormData) {
      let temp = new Map(scanData)
      if (!temp.get('batchNumber') && scanFormData?.[this.dataGoodsKeepingKey]?.batchNumber) {
        temp.set('batchNumber', scanFormData[this.dataGoodsKeepingKey].batchNumber)
      }
      if (!temp.get('periodBegin') && scanFormData?.[this.dataGoodsKeepingKey]?.periodBegin) {
        temp.set('periodBegin', scanFormData[this.dataGoodsKeepingKey].periodBegin)
      }
      if (!temp.get('storageNumber') && scanFormData?.[this.dataGoodsKeepingKey]?.storageNumber) {
        temp.set('storageNumber', scanFormData[this.dataGoodsKeepingKey].storageNumber)
      }
      return temp
    },
    /** @name 将数组的index位置元素挪位到第一个 */
    rowToFrist(arr, index) {
      while (index > 0) {
        let temp = arr[index]
        arr[index] = arr[index - 1]
        arr[index - 1] = temp
        index--
      }
      return [...arr]
    },
    /** @name 灵科的商品结构转化 */
    linkGoods() {
      if (this.dataGoodsInfoKey === 'goodsInfo') {
        const item = this.scanFormData[this.dataGoodsInfoKey]
        const arr = ['manufacturer', 'nature', 'dosage', 'minClaimUnit']
        for (let key of arr) {
          if (key === 'minClaimUnit') {
            this.scanFormData.minClaimUnit = item[key] || null
          } else {
            item[`${key}Name`] = item[key]?.name || null
          }
        }
      }
    },
    /** @name 获取验收结论的key */
    getAcceptStatusKey() {
      return this.dataGoodsKeepingKey === 'goodsStore'
        ? 'acceptStatus'
        : 'attrs.valueEnum.acceptResult'
    },
    /** @name 拆行逻辑 */
    getSplitRow(row) {
      let splitRow = JSON.parse(JSON.stringify(row))
      //主行master强制置为false,计划数量置为null
      splitRow.plan = null
      splitRow.master = false
      splitRow.id = null
      // splitRow.goodsStore.batchNumber= null;
      // splitRow.goodsStore.serialNumber= null;
      // splitRow.goodsStore.periodBegin= null;
      // splitRow.goodsStore.periodExpire= null;
      // splitRow.goodsStore.periodEnd= null;

      // splitRow.amountDisplay=scanAmountDisplay;
      // splitRow.amount=amount;

      splitRow._ID = objectUtil.createID()
      return splitRow
    },
    /** @name Rfid分拆明细，数量设为1，保留1个主行 */
    getSplitRowForRfid(row, ids = [], self = this) {
      const epc = ids[0]
      row[this.dataGoodsKeepingKey].epc = epc
      row.epcs = [epc]
      // 数量设为1
      row[this.dataAmountKey] = 1

      this.store?.dispatch?.('orderBackCountUtil', 'amountBack', row, {})

      // 根据绑定条码的数量进行拆分（不包含原行数据，如果条码数量是 n，这里是需要处理 n-1 条）
      const rfids = ids.slice(1)
      return rfids.reduce((prev, id) => {
        const newRow = this.getSplitRow(row)
        newRow[this.dataGoodsKeepingKey].epc = id
        newRow.epcs = [id]

        // 同步更新 taskData
        this.syncUpdateTaskData(newRow, true, self)
        prev.push(newRow)

        return prev
      }, [])
    },
    setTreeExpand(self = this) {
      if (!self.$refs || !self.$refs.crudDataTableTop) return
      this.$nextTick(() => {
        self.$refs.crudDataTableTop.setAllTreeExpand(true)
        self.$refs.crudDataTableTop.setCurrentRow(null, true)
      })
    },
    saveBefore() {
      return new Promise(async (resolve) => {
        if (this.model === 'checkOrder' || this.model === 'importGoodsAndBatch') {
          const res = await this.$axios
            .post(this.saveUrl, { items: this.tableData, ...this.saveParams })
            .catch(() => {
              resolve(new Response({ data: [], code: 404, msg: '接口请求错误' }))
            })
          resolve(res.data)
        } else {
          resolve(new Response({ data: this.tableData }))
        }
      })
    },
    // *********************************** 设置 Model *********************************** //
    /**
     * @name 录入模式--有源
     * @description 通过所扫商品与任务明细进行匹配，将匹配到的扫码信息更新到任务明细
     * @param {vue} self 指向组件 scanStandardPlus 的上下文
     */
    modelImport(self) {
      let msg = '操作失败，超出上游单据商品范围'
      const { data: scanData } = this.scanResult
      console.log('通过所扫商品与任务明细进行匹配，将匹配到的扫码信息更新到任务明细')
      console.log('scanData: ', scanData)

      console.log('填充到上表的 scanFormData: ', this.scanFormData)
      //如果是编辑则直接填充到上表
      const ifEdit = this.ifEdit(this.scanFormData, false, false, self)
      if (ifEdit) {
        if (ifEdit?.message) throw new Error(ifEdit?.message)
        return { msg: '修改成功' }
      }

      // 查找上表的任务
      let task = this.seachRows(true, self)
      // 校验是否超出上游单据商品范围
      if (!task || !task.size) throw new Error(msg)

      main: for (let [, val] of task) {
        let amoutAll = this.amountTotal(val, `item.${this.dataAmountKey}`)
        let nowAmount = calculateUtil.numberAdd(amoutAll, this.scanFormData[this.dataAmountKey])
        let masterRow = this.seachMaster(val, 'item')

        console.log('nowAmount: ', nowAmount)
        console.log('nowPlan: ', masterRow.item[this.dataPendingKey])

        // 所有主从行的数量之和（包括此次扫码的数量） 小于计划数量时，应该将所扫信息填入到该主从行中的某一行或拆行
        if (nowAmount <= masterRow.item[this.dataPendingKey]) {
          for (let item of val) {
            if (this.checkRowValIsNullforKeys(item.item)) {
              // 如果扫码获取到厂家原始条码，则将 originBarCode 和 originBarCodeDisplay 赋值到任务明细中
              this.setOriginBarCode(item.item)

              // 是否是灵科
              const isLink = this.dataGoodsKeepingKey === 'goodsStore'
              // 更新明细中的生产企业
              if (isLink) {
                item.item[this.dataGoodsInfoKey].manufacturerName =
                  this.scanFormData[this.dataGoodsInfoKey].manufacturerName
              } else {
                item.item[this.dataGoodsInfoKey].manufacturer =
                  this.scanFormData[this.dataGoodsInfoKey].manufacturer
              }

              item.item[this.dataGoodsKeepingKey] = objectUtil.clone(
                this.scanFormData[this.dataGoodsKeepingKey]
              )
              item.item.scanMethod = 'SCAN' // #9818
              setValue(
                item.item,
                this.dataAmountKey,
                calculateUtil.numberAdd(
                  getValue(item.item, this.dataAmountKey),
                  getValue(this.scanFormData, this.dataAmountKey)
                )
              )
              // item.item[this.dataAmountKey] = calculateUtil.numberAdd(
              //   item.item[this.dataAmountKey],
              //   this.scanFormData[this.dataAmountKey]
              // )
              // 开启序列号管理后，校验序列号数量不可大于 1
              msg = this.checkSerialAmount(item.item, this.scanFormData)
              if (msg) break main

              this.store?.dispatch?.('orderBackCountUtil', 'amountBack', item.item, {})
              self.tableData = this.rowToFrist(self.tableData, item.index)
              // 同步更新 taskData
              this.syncUpdateTaskData(self.tableData[0], false, self)
              this.setTreeExpand(self)
              return true
            } else {
              if (
                this.searchFormItem(`${this.dataGoodsKeepingKey}.serialNumber`, [
                  this.diAreaColumns,
                ]) &&
                this.ifSerial(this.scanFormData[this.dataGoodsInfoKey]) &&
                this.checkGoodAndBatchIsEq(item.item, this.scanFormData, [
                  `${this.dataGoodsInfoKey}.id`,
                  `${this.dataGoodsKeepingKey}.batchNumber`,
                  `${this.dataGoodsKeepingKey}.periodBegin`,
                  `${this.dataGoodsKeepingKey}.serialNumber`,
                ])
              ) {
                throw new Error('序列号已存在')
              }

              if (
                !this.ifSerial(this.scanFormData[this.dataGoodsInfoKey]) &&
                this.checkGoodAndBatchIsEq(item.item, this.scanFormData, [
                  `${this.dataGoodsInfoKey}.id`,
                  `${this.dataGoodsKeepingKey}.batchNumber`,
                  `${this.dataGoodsKeepingKey}.periodBegin`,
                ])
              ) {
                // 是否是灵科
                const isLink = this.dataGoodsKeepingKey === 'goodsStore'
                // 更新明细中的生产企业
                if (isLink) {
                  item.item[this.dataGoodsInfoKey].manufacturerName =
                    this.scanFormData[this.dataGoodsInfoKey].manufacturerName
                } else {
                  item.item[this.dataGoodsInfoKey].manufacturer =
                    this.scanFormData[this.dataGoodsInfoKey].manufacturer
                }

                item.item[this.dataGoodsKeepingKey] = objectUtil.clone(
                  this.scanFormData[this.dataGoodsKeepingKey]
                )
                item.item.scanMethod = 'SCAN' // #9818
                setValue(
                  item.item,
                  this.dataAmountKey,
                  calculateUtil.numberAdd(
                    getValue(item.item, this.dataAmountKey),
                    getValue(this.scanFormData, this.dataAmountKey)
                  )
                )
                // item.item[this.dataAmountKey] = calculateUtil.numberAdd(
                //   item.item[this.dataAmountKey],
                //   this.scanFormData[this.dataAmountKey]
                // )
                // 开启序列号管理后，校验序列号数量不可大于 1
                msg = this.checkSerialAmount(item.item, this.scanFormData)
                if (msg) break main

                this.store?.dispatch?.('orderBackCountUtil', 'amountBack', item.item, {})
                self.tableData = this.rowToFrist(self.tableData, item.index)
                // 同步更新 taskData
                this.syncUpdateTaskData(self.tableData[0], false, self)
                this.setTreeExpand(self)
                return true
              }
            }
          }

          // 执行到这里说明应该进行拆行
          let newRow = this.getSplitRow(masterRow.item)

          // 如果扫码获取到厂家原始条码，则将 originBarCode 和 originBarCodeDisplay 赋值到任务明细中
          this.setOriginBarCode(newRow)

          // 是否是灵科
          const isLink = this.dataGoodsKeepingKey === 'goodsStore'
          // 更新明细中的生产企业
          if (isLink) {
            newRow[this.dataGoodsInfoKey].manufacturerName =
              this.scanFormData[this.dataGoodsInfoKey].manufacturerName
          } else {
            newRow[this.dataGoodsInfoKey].manufacturer =
              this.scanFormData[this.dataGoodsInfoKey].manufacturer
          }

          newRow[this.dataGoodsKeepingKey] = objectUtil.clone(
            this.scanFormData[this.dataGoodsKeepingKey]
          )
          newRow[this.dataAmountKey] = this.scanFormData[this.dataAmountKey]
          newRow.scanMethod = 'SCAN' // #9818
          // 开启序列号管理后，校验序列号数量不可大于 1
          msg = this.checkSerialAmount(newRow, this.scanFormData)
          if (msg) break main

          this.store?.dispatch?.('orderBackCountUtil', 'amountBack', newRow, {})
          self.tableData = [newRow, ...self.tableData]
          // 同步更新 taskData
          this.syncUpdateTaskData(newRow, true, self)
          this.setTreeExpand(self)

          return true
        } else {
          msg = '操作失败，超出上游单据数量范围'
        }
      }

      throw new Error(msg)
    },
    /**
     * @name 录入模式--有源-如果注册证号和生产许可证不同，则拆行
     * @description 通过所扫商品与任务明细进行匹配，将匹配到的扫码信息更新到任务明细
     * @param {vue} self 指向组件 scanStandardPlus 的上下文
     */
    modelImportAndRegCert(self) {
      let msg = '操作失败，超出上游单据商品范围'
      const { data: scanData } = this.scanResult
      console.log(
        '通过所扫商品与任务明细进行匹配，将匹配到的扫码信息更新到任务明细，如果注册证号和生产许可证不同，则拆行'
      )
      console.log('scanData: ', scanData)

      console.log('填充到上表的 scanFormData: ', this.scanFormData)
      //如果是编辑则直接填充到上表
      const ifEdit = this.ifEdit(this.scanFormData, false, false, self)
      if (ifEdit) {
        if (ifEdit?.message) throw new Error(ifEdit?.message)
        return { msg: '修改成功' }
      }

      // 查找上表的任务
      let task = this.seachRows(true, self)
      // 校验是否超出上游单据商品范围
      if (!task || !task.size) throw new Error(msg)

      main: for (let [, val] of task) {
        let amoutAll = this.amountTotal(val, `item.${this.dataAmountKey}`)
        let nowAmount = calculateUtil.numberAdd(amoutAll, this.scanFormData[this.dataAmountKey])
        let masterRow = this.seachMaster(val, 'item')

        console.log('nowAmount: ', nowAmount)
        console.log('nowPlan: ', masterRow.item[this.dataPendingKey])

        // 所有主从行的数量之和（包括此次扫码的数量） 小于计划数量时，应该将所扫信息填入到该主从行中的某一行或拆行
        if (nowAmount <= masterRow.item[this.dataPendingKey]) {
          for (let item of val) {
            if (this.checkRowValIsNullforKeys(item.item)) {
              // 是否是灵科
              const isLink = this.dataGoodsKeepingKey === 'goodsStore'
              // 更新明细中的生产企业
              if (isLink) {
                item.item[this.dataGoodsInfoKey].manufacturerName =
                  this.scanFormData[this.dataGoodsInfoKey].manufacturerName
              } else {
                item.item[this.dataGoodsInfoKey].manufacturer =
                  this.scanFormData[this.dataGoodsInfoKey].manufacturer
              }

              item.item[this.dataGoodsKeepingKey] = objectUtil.clone(
                this.scanFormData[this.dataGoodsKeepingKey]
              )
              item.item.scanMethod = 'SCAN' // #9818
              setValue(
                item.item,
                this.dataAmountKey,
                calculateUtil.numberAdd(
                  getValue(item.item, this.dataAmountKey),
                  getValue(this.scanFormData, this.dataAmountKey)
                )
              )

              // 如果扫码获取到厂家原始条码，则将 originBarCode 和 originBarCodeDisplay 赋值到任务明细中
              this.setOriginBarCode(item.item)
              // item.item[this.dataAmountKey] = calculateUtil.numberAdd(
              //   item.item[this.dataAmountKey],
              //   this.scanFormData[this.dataAmountKey]
              // )
              // 开启序列号管理后，校验序列号数量不可大于 1
              msg = this.checkSerialAmount(item.item, this.scanFormData)
              if (msg) break main

              this.store?.dispatch?.('orderBackCountUtil', 'amountBack', item.item, {})
              self.tableData = this.rowToFrist(self.tableData, item.index)
              // 同步更新 taskData
              this.syncUpdateTaskData(self.tableData[0], false, self)
              this.setTreeExpand(self)
              return true
            } else {
              if (
                this.searchFormItem(`${this.dataGoodsKeepingKey}.serialNumber`, [
                  this.diAreaColumns,
                ]) &&
                this.ifSerial(this.scanFormData[this.dataGoodsInfoKey]) &&
                this.checkGoodAndBatchIsEq(item.item, this.scanFormData, [
                  `${this.dataGoodsInfoKey}.id`,
                  `${this.dataGoodsKeepingKey}.batchNumber`,
                  `${this.dataGoodsKeepingKey}.periodBegin`,
                  `${this.dataGoodsKeepingKey}.serialNumber`,
                ])
              ) {
                throw new Error('序列号已存在')
              }

              if (
                !this.ifSerial(this.scanFormData[this.dataGoodsInfoKey]) &&
                this.checkGoodAndBatchIsEq(item.item, this.scanFormData, [
                  `${this.dataGoodsInfoKey}.id`,
                  `${this.dataGoodsKeepingKey}.batchNumber`,
                  `${this.dataGoodsKeepingKey}.periodBegin`,
                  `${this.dataGoodsKeepingKey}.registration.id`,
                  `${this.dataGoodsKeepingKey}.certification.id`,
                ])
              ) {
                // 是否是灵科
                const isLink = this.dataGoodsKeepingKey === 'goodsStore'
                // 更新明细中的生产企业
                if (isLink) {
                  item.item[this.dataGoodsInfoKey].manufacturerName =
                    this.scanFormData[this.dataGoodsInfoKey].manufacturerName
                } else {
                  item.item[this.dataGoodsInfoKey].manufacturer =
                    this.scanFormData[this.dataGoodsInfoKey].manufacturer
                }

                item.item[this.dataGoodsKeepingKey] = objectUtil.clone(
                  this.scanFormData[this.dataGoodsKeepingKey]
                )
                item.item.scanMethod = 'SCAN' // #9818
                setValue(
                  item.item,
                  this.dataAmountKey,
                  calculateUtil.numberAdd(
                    getValue(item.item, this.dataAmountKey),
                    getValue(this.scanFormData, this.dataAmountKey)
                  )
                )
                // 如果扫码获取到厂家原始条码，则将 originBarCode 和 originBarCodeDisplay 赋值到任务明细中
                this.setOriginBarCode(item.item)
                // item.item[this.dataAmountKey] = calculateUtil.numberAdd(
                //   item.item[this.dataAmountKey],
                //   this.scanFormData[this.dataAmountKey]
                // )
                // 开启序列号管理后，校验序列号数量不可大于 1
                msg = this.checkSerialAmount(item.item, this.scanFormData)
                if (msg) break main

                this.store?.dispatch?.('orderBackCountUtil', 'amountBack', item.item, {})
                self.tableData = this.rowToFrist(self.tableData, item.index)
                // 同步更新 taskData
                this.syncUpdateTaskData(self.tableData[0], false, self)
                this.setTreeExpand(self)
                return true
              }
            }
          }

          // 执行到这里说明应该进行拆行
          let newRow = this.getSplitRow(masterRow.item)

          // 是否是灵科
          const isLink = this.dataGoodsKeepingKey === 'goodsStore'
          // 更新明细中的生产企业
          if (isLink) {
            newRow[this.dataGoodsInfoKey].manufacturerName =
              this.scanFormData[this.dataGoodsInfoKey].manufacturerName
          } else {
            newRow[this.dataGoodsInfoKey].manufacturer =
              this.scanFormData[this.dataGoodsInfoKey].manufacturer
          }

          newRow[this.dataGoodsKeepingKey] = objectUtil.clone(
            this.scanFormData[this.dataGoodsKeepingKey]
          )
          newRow[this.dataAmountKey] = this.scanFormData[this.dataAmountKey]
          newRow.scanMethod = 'SCAN' // #9818

          // 如果扫码获取到厂家原始条码，则将 originBarCode 和 originBarCodeDisplay 赋值到任务明细中
          this.setOriginBarCode(newRow)

          // 开启序列号管理后，校验序列号数量不可大于 1
          msg = this.checkSerialAmount(newRow, this.scanFormData)
          if (msg) break main

          this.store?.dispatch?.('orderBackCountUtil', 'amountBack', newRow, {})
          self.tableData = [newRow, ...self.tableData]
          // 同步更新 taskData
          this.syncUpdateTaskData(newRow, true, self)
          this.setTreeExpand(self)

          return true
        } else {
          msg = '操作失败，超出上游单据数量范围'
        }
      }

      throw new Error(msg)
    },
    /**
     * @name 录入模式--有源
     * @description 通过所扫商品与任务明细进行匹配，将匹配到的扫码信息更新到任务明细
     * @param {vue} self 指向组件 scanStandardPlus 的上下文
     *
     */
    modelMatchAndImport(self) {
      let msg = '操作失败，超出上游单据商品范围'
      const { data: scanData } = this.scanResult
      console.log('通过所扫商品与任务明细进行匹配，将匹配到的扫码信息更新到任务明细')
      console.log('scanData: ', scanData)

      console.log('填充到上表的 scanFormData: ', this.scanFormData)
      //如果是编辑则直接填充到上表
      const ifEdit = this.ifEdit(this.scanFormData, false, false, self)
      if (ifEdit) {
        if (ifEdit?.message) throw new Error(ifEdit?.message)
        return { msg: '修改成功' }
      }

      // 查找上表的任务
      let task = this.seachRows(true, self)
      // 校验是否超出上游单据商品范围
      if (!task || !task.size) throw new Error(msg)

      // const checkArr = [
      //   `${this.dataGoodsInfoKey}.id`,
      //   `${this.dataGoodsKeepingKey}.periodBegin`,
      //   `${this.dataGoodsKeepingKey}.batchNumber`,
      // ]
      const checkArr = this.setCheckArr()
      const ifSerial = scanUtils.ifSerial(
        this.scanFormData,
        `${this.dataGoodsInfoKey}.keepingSerial`
      )
      if (ifSerial) checkArr.push(`${this.dataGoodsKeepingKey}.serialNumber`)
      console.log('checkArr: ', checkArr)

      main: for (let [, val] of task) {
        let amoutAll = this.amountTotal(val, `item.${this.dataAmountKey}`)
        let nowAmount = calculateUtil.numberAdd(amoutAll, this.scanFormData[this.dataAmountKey])
        let masterRow = this.seachMaster(val, 'item')

        console.log('nowAmount: ', nowAmount)
        console.log('nowPlan: ', masterRow.item[this.dataPendingKey])

        // 所有主从行的数量之和（包括此次扫码的数量） 小于计划数量时，应该将所扫信息填入到该主从行中的某一行或拆行
        if (
          nowAmount <= masterRow.item[this.dataPendingKey] &&
          nowAmount <= masterRow.item?.remain
        ) {
          for (let item of val) {
            if (
              this.checkRowValIsNullforKeys(item.item) &&
              this.checkGoodsIsEq(item.item, this.scanFormData)
            ) {
              // 如果扫码获取到厂家原始条码，则将 originBarCode 和 originBarCodeDisplay 赋值到任务明细中
              this.setOriginBarCode(item.item)

              item.item[this.dataGoodsKeepingKey] = objectUtil.clone(
                this.scanFormData[this.dataGoodsKeepingKey]
              )
              setValue(
                item.item,
                this.dataAmountKey,
                calculateUtil.numberAdd(
                  getValue(item.item, this.dataAmountKey),
                  getValue(this.scanFormData, this.dataAmountKey)
                )
              )
              // item.item[this.dataAmountKey] = calculateUtil.numberAdd(
              //   item.item[this.dataAmountKey],
              //   this.scanFormData[this.dataAmountKey]
              // )

              this.store?.dispatch?.('orderBackCountUtil', 'amountBack', item.item, {})
              self.tableData = this.rowToFrist(self.tableData, item.index)
              // 同步更新 taskData
              this.syncUpdateTaskData(self.tableData[0], false, self)
              this.setTreeExpand(self)
              return true
            } else {
              if (
                this.searchFormItem(`${this.dataGoodsKeepingKey}.serialNumber`, [
                  this.diAreaColumns,
                ]) &&
                this.ifSerial(this.scanFormData[this.dataGoodsInfoKey]) &&
                this.checkGoodAndBatchIsEq(item.item, this.scanFormData, [
                  `${this.dataGoodsKeepingKey}.serialNumber`,
                ])
              ) {
                msg = '序列号已存在'
                continue main
              }
              if (
                !this.ifSerial(this.scanFormData[this.dataGoodsInfoKey]) &&
                this.checkGoodAndBatchIsEq(item.item, this.scanFormData, [
                  `${this.dataGoodsInfoKey}.id`,
                  `${this.dataGoodsKeepingKey}.batchNumber`,
                  `${this.dataGoodsKeepingKey}.periodBegin`,
                ])
              ) {
                // 如果扫码的库存信息在对应商品任务明细中一样则进行数量累加
                setValue(
                  item.item,
                  this.dataAmountKey,
                  calculateUtil.numberAdd(
                    getValue(item.item, this.dataAmountKey),
                    getValue(this.scanFormData, this.dataAmountKey)
                  )
                )
                // item.item[this.dataAmountKey] = calculateUtil.numberAdd(
                //   item.item[this.dataAmountKey],
                //   this.scanFormData[this.dataAmountKey]
                // )

                this.store?.dispatch?.('orderBackCountUtil', 'amountBack', item.item, {})
                self.tableData = this.rowToFrist(self.tableData, item.index)
                // 同步更新 taskData
                this.syncUpdateTaskData(self.tableData[0], false, self)
                this.setTreeExpand(self)
                return true
              }
            }
          }
        } else {
          msg = '操作失败，超出上游单据数量范围'
        }
      }

      const tmpArr = [
        `${this.dataGoodsKeepingKey}.batchNumber`,
        `${this.dataGoodsKeepingKey}.periodBegin`,
      ]
      if (ifSerial) tmpArr.push(`${this.dataGoodsKeepingKey}.serialNumber`)
      for (const [, val] of task) {
        let amoutAll = this.amountTotal(val, `item.${this.dataAmountKey}`)
        let nowAmount = calculateUtil.numberAdd(amoutAll, this.scanFormData[this.dataAmountKey])
        let masterRow = this.seachMaster(val, 'item')
        // 所有主从行的数量之和（包括此次扫码的数量） 小于计划数量时，应该将所扫信息填入到该主从行中的某一行或拆行
        if (
          nowAmount <= masterRow.item[this.dataPendingKey] &&
          nowAmount <= masterRow.item?.remain
        ) {
          for (const item of val) {
            if (
              this.checkGoodsIsEq(item.item, this.scanFormData) &&
              !this.checkGoodAndBatchIsEq(item.item, this.scanFormData, tmpArr)
            ) {
              // 执行到这里说明应该进行拆行
              let newRow = this.getSplitRow(masterRow.item)
              // 如果扫码获取到厂家原始条码，则将 originBarCode 和 originBarCodeDisplay 赋值到任务明细中
              this.setOriginBarCode(newRow)
              newRow[this.dataGoodsKeepingKey] = objectUtil.clone(
                this.scanFormData[this.dataGoodsKeepingKey]
              )
              newRow[this.dataAmountKey] = this.scanFormData[this.dataAmountKey]

              this.store?.dispatch?.('orderBackCountUtil', 'amountBack', newRow, {})
              self.tableData = [newRow, ...self.tableData]
              // 同步更新 taskData
              this.syncUpdateTaskData(newRow, true, self)
              this.setTreeExpand(self)
              return true
            }
          }
        } else {
          msg = '操作失败，超出上游单据数量范围'
        }
      }

      return msg
    },
    //录入模式--无源--跟台商品目录池，将所扫商品及批号信息添加进上表，最后保存直接调后台接口
    modelimportGoodsAndBatch(self) {
      self.tableData = [this.scanFormData, ...self.tableData]
      // 同步更新 taskData
      this.syncUpdateTaskData(this.scanFormData, true)

      this.setTreeExpand()
    },
    // 录入模式--无源--来自跟台目录，根据所扫商品与上表进行匹配，相同则数量累加，否则根据接口获取当前明细行，并加入上表
    async modelImportGoodsAndBatchByTrack(self) {
      console.log(
        '录入模式--无源--来自跟台目录，根据所扫商品与上表进行匹配，相同则数量累加，否则根据接口获取当前明细行，并加入上表'
      )
      let checkArr = [
        `${this.dataGoodsKeepingKey}.periodBegin`,
        `${this.dataGoodsKeepingKey}.periodEnd`,
        `${this.dataGoodsKeepingKey}.batchNumber`,
      ]
      // let checkArr = this.setCheckArr()
      if (getValue(this.scanFormData, `${this.dataGoodsInfoKey}.id`)) {
        checkArr.unshift(`${this.dataGoodsInfoKey}.id`)
      }
      let serialNumber = getValue(this.scanFormData, `${this.dataGoodsKeepingKey}.serialNumber`)
      let serialNumberIndex = this.checkSerialNumberOnly(serialNumber, self.tableData)
      if (serialNumber && serialNumberIndex !== -1) {
        let serialNumberItem = self.tableData[serialNumberIndex]
        let nowAmount = calculateUtil.numberAdd(
          serialNumberItem[this.dataAmountKey],
          this.scanFormData[this.dataAmountKey]
        )
        if (
          nowAmount > 1 &&
          this.checkGoodAndBatchIsEq(serialNumberItem, this.scanFormData, checkArr, '', true)
        ) {
          return '该商品已开启序列号管理数量不能大于1'
        } else if (
          !this.checkGoodAndBatchIsEq(serialNumberItem, this.scanFormData, checkArr, '', true)
        ) {
          return '保存失败，原因是序列号已经存在'
        } else {
          serialNumberItem[this.dataAmountKey] = nowAmount
          this.store?.dispatch?.('orderBackCountUtil', 'amountBack', serialNumberItem, {})
          self.tableData = this.rowToFrist(self.tableData, serialNumberIndex)
          // 同步更新 taskData
          this.syncUpdateTaskData(self.tableData[0], false, self)

          this.setTreeExpand(self)
          return
        }
      }
      for (let i = 0; i < self.tableData.length; i++) {
        let item = self.tableData[i]
        let nowAmount = calculateUtil.numberAdd(
          item[this.dataAmountKey],
          this.scanFormData[this.dataAmountKey]
        )
        let tempArr = getValue(item, `${this.dataGoodsKeepingKey}.serialNumber`)
          ? [...checkArr, `${this.dataGoodsKeepingKey}.serialNumber`]
          : checkArr
        if (
          this.checkGoodAndBatchIsEq(item, this.scanFormData, tempArr, '', true) &&
          (!this.ifSerial(this.scanFormData[this.dataGoodsInfoKey]) ||
            (this.ifSerial(this.scanFormData[this.dataGoodsInfoKey]) && nowAmount <= 1))
        ) {
          if (
            getValue(this.scanFormData, `${this.dataGoodsKeepingKey}.serialNumber`) &&
            !getValue(item, `${this.dataGoodsKeepingKey}.serialNumber`)
          ) {
            setValue(
              item,
              `${this.dataGoodsKeepingKey}.serialNumber`,
              getValue(this.scanFormData, `${this.dataGoodsKeepingKey}.serialNumber`)
            )
          }
          // 更新明细中的生产企业
          item[this.dataGoodsInfoKey].manufacturerName =
            this.scanFormData[this.dataGoodsInfoKey].manufacturerName

          item[this.dataAmountKey] = nowAmount
          for (let key in this.scanFormData[this.dataGoodsKeepingKey]) {
            if (this.scanFormData[this.dataGoodsKeepingKey][key]) {
              item[this.dataGoodsKeepingKey][key] = this.scanFormData[this.dataGoodsKeepingKey][key]
            }
          }
          this.store?.dispatch?.('orderBackCountUtil', 'amountBack', item, {})
          self.tableData = this.rowToFrist(self.tableData, i)
          // 同步更新 taskData
          this.syncUpdateTaskData(self.tableData[0], false, self)

          this.setTreeExpand(self)
          return
        }
      }
      //如果没有匹配的就新增一条
      let param = Object.assign({}, this.importGoodsAndBatchByTrackParam)
      param.parameters = Object.assign(
        {
          goodsId: this.scanFormData[this.dataGoodsInfoKey].id,
          batchNumer: this.scanFormData[this.dataGoodsKeepingKey].batchNumber,
        },
        this.importGoodsAndBatchByTrackParam?.parameters
      )
      const scanFormData = this.scanFormData // 接口异步调用后，this.scanFormData 可能被重置，所以此处先缓存
      const res = await this.$axios.post(this.importGoodsAndBatchByTrackUrl, param)
      if (res.data.code == 200 && res.data.data && res.data.data.length > 0) {
        let item = res.data.data[0]
        for (let key in scanFormData[this.dataGoodsKeepingKey]) {
          if (scanFormData[this.dataGoodsKeepingKey][key]) {
            item[this.dataGoodsKeepingKey][key] = scanFormData[this.dataGoodsKeepingKey][key]
          }
        }
        if (this.ifSerial(item[this.dataGoodsInfoKey]) && scanFormData[this.dataAmountKey] > 1) {
          return '当前商品已开启序列号管理，数量不能大于1'
        }
        // 更新明细中的生产企业
        item[this.dataGoodsInfoKey].manufacturerName =
          scanFormData[this.dataGoodsInfoKey].manufacturerName

        item[this.dataAmountKey] = scanFormData[this.dataAmountKey]
        this.store?.dispatch?.('orderBackCountUtil', 'amountBack', item, {})
        self.tableData = [item, ...self.tableData]
        // 同步更新 taskData
        this.syncUpdateTaskData(item, true, self)
        this.setTreeExpand(self)

        return true
      } else {
        return res.data.msg || '未查询到该商品'
      }
    },
    /**
     * @name 录入模式--无源
     * @description 扫码后通过接口去查询商品信息，根据商品信息匹配并累加数量，未匹配则新增
     * @param {vue} self 指向组件 scanStandardPlus 的上下文
     *
     */
    async modelImportInventory(self) {
      let msg = '找不到可用的库存数据，请仔细检查'
      const { data: scanData } = this.scanResult
      console.log('扫码后通过接口去查询库存，根据库存ID匹配并累加数量，未匹配则新增')
      console.log('scanData: ', scanData)

      console.log('填充到上表的 scanFormData: ', this.scanFormData)
      if (this.scanFormData[this.dataAmountKey] > this.scanFormData.available) {
        return '库存不足'
      }
      this.linkGoods() //转换灵科的结构

      const importInventoryUrl = self?.importInventoryUrl
      const importInventoryParam = { ...self?.importInventoryParam }
      let param = { items: [this.scanFormData], ...importInventoryParam }

      const res = await this.$axios.post(importInventoryUrl, param)
      if (res.data.code == 200 && res.data.data && res.data.data.length > 0) {
        let item = res.data.data[0]
        for (let i = 0; i < self.tableData.length; i++) {
          let row = self.tableData[i]
          if (this.checkBatchIsEq(row, item)) {
            row[this.dataAmountKey] = calculateUtil.numberAdd(
              this.scanFormData[this.dataAmountKey],
              row[this.dataAmountKey]
            )

            this.store?.dispatch?.('orderBackCountUtil', 'amountBack', row, {})
            self.tableData = this.rowToFrist(self.tableData, i)
            // 同步更新 taskData
            this.syncUpdateTaskData(self.tableData[0], false, self)

            this.setTreeExpand(self)
            return true
          }
        }

        // 未匹配则新增
        item[this.dataAmountKey] = this.scanFormData[this.dataAmountKey]

        this.store?.dispatch?.('orderBackCountUtil', 'amountBack', item, {})
        self.tableData = [item, ...self.tableData]
        // 同步更新 taskData
        this.syncUpdateTaskData(item, true, self)

        this.setTreeExpand(self)
        return true
      }

      throw new Error(msg)
    },
    /**
     * @name 录入模式--无源
     * @description 扫码后通过接口去查询库存，根据库存ID匹配并累加数量，未匹配则新增
     * @param {vue} self 指向组件 scanStandardPlus 的上下文
     * @param {any[]} [stockData=[]] 库存数据
     *
     */
    async modelImportInventoryByStock(self, stockData = []) {
      let msg = '找不到可用的库存数据，请仔细检查'
      // 校验库存选择器选中的数据合法性
      const newStockData = scanUtils.checkStockData(stockData, this)
      const { data: scanData } = this.scanResult
      console.log('扫码后通过接口去查询库存，根据库存ID匹配并累加数量，未匹配则新增')
      console.log('scanData: ', scanData)
      console.log('scanFormData: ', this.scanFormData)

      const importInventoryUrl = self?.importInventoryUrl
      const importInventoryParam = { ...self?.importInventoryParam }

      if (newStockData.length === 0) {
        throw new Error(msg)
      }

      main: for (const stock of newStockData) {
        // 从库存选择器表格中获取数据更新 scanFormData
        scanUtils.updateScanFormDataByStockRow(stock, this)
        console.log('填充到上表的 scanFormData: ', this.scanFormData)
        console.log('stock: ', stock)
        let stockAmount =
          !this.stockAutoUrl && this.dataAmountKey in stock
            ? stock[this.dataAmountKey]
            : stock.amountOut

        this.linkGoods() //转换灵科的结构

        let param = { items: [this.scanFormData], ...importInventoryParam }
        const res = await this.$axios.post(importInventoryUrl, param)
        if (res.data.code == 200 && res.data.data && res.data.data.length > 0) {
          let item = res.data.data[0]
          for (let i = 0; i < self.tableData.length; i++) {
            let row = self.tableData[i]
            if (this.checkBatchIsEq(row, item)) {
              row[this.dataAmountKey] = calculateUtil.numberAdd(
                stockAmount, // #35628，扫码累加数量问题，应该用选择库存数据后的行库存数据的数量进行累加
                row[this.dataAmountKey]
              )
              console.log('行数据: ', row)
              console.log('行数据累加后的数量: ', row[this.dataAmountKey])

              this.store?.dispatch?.('orderBackCountUtil', 'amountBack', row, {})
              self.tableData = this.rowToFrist(self.tableData, i)
              // 同步更新 taskData
              this.syncUpdateTaskData(self.tableData[0], false, self)

              this.setTreeExpand(self)
              continue main
            }
          }

          // 未匹配则新增
          item[this.dataAmountKey] = stockAmount

          this.store?.dispatch?.('orderBackCountUtil', 'amountBack', item, {})
          // #8365 处理添加到明细的数据
          const allData = self.tableData
          const prev = allData[0]
          if (prev?.instrument) item.instrument = prev.instrument

          self.tableData = [item, ...self.tableData]
          // 同步更新 taskData
          this.syncUpdateTaskData(item, true, self)

          this.setTreeExpand(self)
          continue main
        }

        throw new Error(msg)
      }

      return true
    },
    /**
     * @name 录入模式--有源
     * @description 通过所扫商品与任务明细进行匹配，将扫码信息查询的库存录入到任务明细
     * @param {vue} self 指向组件 scanStandardPlus 的上下文
     * @param {any[]} [stockData=[]] 库存数据
     * @returns
     */
    modelImportForStock(self, stockData = []) {
      let msg = '操作失败，超出上游单据商品范围'
      // 校验库存选择器选中的数据合法性
      const newStockData = scanUtils.checkStockData(stockData, this)

      main: for (const stock of newStockData) {
        // 从库存选择器表格中获取数据更新数量
        setValue(this.scanFormData, `${this.dataAmountKey}`, stock[`${this.dataAmountKey}`])
        // 从库存选择器表格中获取数据更新 scanFormData
        scanUtils.updateScanFormDataByStockRow(stock, this)

        console.log('填充到上表的 scanFormData: ', this.scanFormData)
        //如果是编辑则直接填充到上表
        const ifEdit = this.ifEdit(this.scanFormData, true, false, self)
        if (ifEdit) {
          if (ifEdit?.message) throw new Error(ifEdit?.message)
          continue
        }

        // if (this.scanFormData[this.dataAmountKey] > stock.available) {
        //   msg = '库存不足'
        //   throw new Error(msg)
        // }

        // 转换灵科的结构
        this.linkGoods()

        // 查找上表的任务
        let task = this.seachRows(true, self)

        for (let [, val] of task) {
          console.log(val, 'val')
          let amoutAll = this.amountTotal(val, `item.${this.dataAmountKey}`)
          let planAll = this.amountTotal(val, `item.${this.dataPendingKey}`)
          let nowAmount = calculateUtil.numberAdd(amoutAll, this.scanFormData[this.dataAmountKey])
          let masterRow = this.seachMaster(val, 'item')

          console.log('planAll: ', planAll)
          console.log('nowAmount: ', nowAmount)
          // 所有主从行的数量之和（包括此次扫码的数量） 小于计划数量时，应该将所扫信息填入到该主从行中的某一行或拆行
          if (nowAmount > planAll) {
            throw new Error('操作失败，超出上游单据数量范围')
          } else {
            for (let item of val) {
              // 优化线上问题（上海先进）#32410, 校验是否存在相同库存信息的不同商品
              let flag = this.checkStorageItemIdAndGoodsId(item.item, this.scanFormData)
              if (flag) throw new Error(flag)

              if (
                !getValue(
                  item.item,
                  this.dataGoodsKeepingKey === 'goodsStore'
                    ? 'goodsStore.storageItemId'
                    : 'storageItem.id'
                )
              ) {
                item.item = Object.assign(item.item, this.scanFormData)

                this.store?.dispatch?.('orderBackCountUtil', 'amountBack', item.item, {})
                self.tableData = this.rowToFrist(self.tableData, item.index)
                // 同步更新 taskData
                this.syncUpdateTaskData(self.tableData[0])
                this.setTreeExpand(self)
                continue main
              } else if (this.checkBatchIsEq(item.item, this.scanFormData)) {
                //如果扫码的库存信息在对应商品任务明细中一样则进行数量累加
                setValue(
                  item.item,
                  this.dataAmountKey,
                  calculateUtil.numberAdd(
                    getValue(item.item, this.dataAmountKey),
                    getValue(this.scanFormData, this.dataAmountKey)
                  )
                )
                // item.item[this.dataAmountKey] = calculateUtil.numberAdd(
                //   item.item[this.dataAmountKey],
                //   this.scanFormData[this.dataAmountKey]
                // )

                this.store?.dispatch?.('orderBackCountUtil', 'amountBack', item.item, {})
                self.tableData = this.rowToFrist(self.tableData, item.index)
                // 同步更新 taskData
                this.syncUpdateTaskData(self.tableData[0])
                this.setTreeExpand(self)
                continue main
              }
            }

            // 执行到这里说明应该进行拆行
            let newRow = this.getSplitRow(masterRow.item)
            newRow = Object.assign(newRow, this.scanFormData)

            this.store?.dispatch?.('orderBackCountUtil', 'amountBack', newRow, {})
            self.tableData = [newRow, ...self.tableData]
            // 同步更新 taskData
            this.syncUpdateTaskData(newRow, true)
            this.setTreeExpand(self)
            continue main
          }
        }

        throw new Error(msg)
      }

      return true
    },
    /**
     * @name 匹配模式--有源
     * @description 根据扫码信息在明细中查询，点击确认时将查询出来的明细添加到上表，数量相同就累加，最后点击保存时提交到后台
     * @returns
     */
    modelCheckOrder(self) {
      let msg = '操作失败，超出上游单据商品范围'
      // const { data: scanData } = this.scanResult
      console.log(
        '根据扫码信息在明细中查询，点击确认时将查询出来的明细添加到上表，数量相同就累加，最后点击保存时提交到后台'
      )
      console.log('填充到上表的 scanFormData: ', this.scanFormData)
      // 是否是编辑，只判断不执行修改
      let ifEdit = this.ifEdit(this.scanFormData, true, true, self, true)

      const nowAmount = this.scanFormData[this.dataAmountKey]
      const ifSerial =
        scanUtils.ifSerial(this.scanFormData, `${this.dataGoodsInfoKey}.keepingSerial`) &&
        this.searchFormItem(`${this.dataGoodsKeepingKey}.serialNumber`, [this.diAreaColumns])

      // 查找上表的任务
      let task = this.seachRows(false, self)
      // 校验是否超出上游单据商品范围
      if (!task || !task.size) {
        if (ifSerial && nowAmount > 1) msg = '该商品已开启序列号管理，数量不可大于 1'
        throw new Error(msg)
      }

      // 扫码扫到序列号
      for (const [, item] of task) {
        if (!ifSerial) continue

        const amount = ifEdit
          ? nowAmount
          : calculateUtil.numberAdd(item[this.dataStockingAmountKey], nowAmount)

        if (
          amount > 1 &&
          this.checkGoodAndBatchIsEq(item, this.scanFormData, [
            `${this.dataGoodsKeepingKey}.batchNumber`,
            `${this.dataGoodsKeepingKey}.serialNumber`,
          ])
        ) {
          throw new Error('该商品已开启序列号管理，数量不可大于 1')
        }
        if (
          !ifEdit &&
          item[this.dataStockingAmountKey] === 1 &&
          this.checkGoodAndBatchIsEq(item, this.scanFormData, [
            `${this.dataGoodsKeepingKey}.batchNumber`,
            `${this.dataGoodsKeepingKey}.serialNumber`,
          ])
        ) {
          throw new Error('序列号已存在')
        }
      }

      // 更新待校验项
      const updateCheckArr = () => {
        const checkArr = this.setCheckArr()
        checkArr.push(`${this.dataGoodsInfoKey}.id`)
        if (ifSerial) checkArr.push(`${this.dataGoodsKeepingKey}.serialNumber`)

        console.log('checkArr: ', checkArr)
        return checkArr
      }

      // 任务明细是否已更新过
      let haveUpdated = false

      const storageMap = new Map()
      // 处理其他扫码信息
      for (const [index, item] of task) {
        // 数量
        const amount = ifEdit
          ? nowAmount
          : calculateUtil.numberAdd(item[this.dataStockingAmountKey], nowAmount)
        // 待校验项
        const checkArr = updateCheckArr()
        // 找到商品ID、批号、生产日期和效期相同的数据
        if (this.checkGoodAndBatchIsEq(item, this.scanFormData, checkArr)) {
          const storageNumber = getValue(item, `${this.dataGoodsKeepingKey}.storageNumber`)
          if (storageNumber) {
            storageMap.set(storageNumber, {
              item,
              index,
            })
          }
          // 盘点数量是否大于可用量
          let ifGtStocking =
            item[this.dataStockingAmountKey] && item.stocking < item[this.dataStockingAmountKey]
          // 判断行数据的盘点数量是否大于可用量
          if (ifGtStocking) continue

          // 编辑则更新数量
          item[this.dataAmountKey] = amount
          item[this.dataStockingAmountKey] = amount

          self.tableData = this.rowToFrist(self.tableData, index)
          // 同步更新 taskData
          this.syncUpdateTaskData(self.tableData[0], false, self)
          this.setTreeExpand(self)

          haveUpdated = true
          break
        }
      }

      // 执行到这里就匹配扫码的信息是否在明细中，如果在就随机更新【盘点数量】
      const updates = []
      for (let [, item] of task) {
        // 待校验项
        const checkArr = updateCheckArr()
        // 盘点数量是否大于可用量
        let ifGtStocking =
          item[this.dataStockingAmountKey] && item.stocking < item[this.dataStockingAmountKey]

        if (ifGtStocking && this.checkGoodAndBatchIsEq(item, this.scanFormData, checkArr)) {
          updates.push(item)
        }
      }

      // 任务数量和盘点数量大于可用量的任务数量相等，则执行随机更新盘点数量的逻辑
      console.log(task.size, updates.length, haveUpdated)
      if (!haveUpdated && task.size === updates.length) {
        const nIndex = objectUtil.getRandomNum(0, updates.length - 1) || 0
        console.log('随机生成的下标: ', nIndex)
        const item = updates[nIndex] // 应改为随机下标

        // 数量
        const amount = ifEdit
          ? nowAmount
          : calculateUtil.numberAdd(item[this.dataStockingAmountKey], nowAmount)
        console.log(ifEdit, item[this.dataStockingAmountKey], nowAmount, amount, item)
        // 编辑则更新数量
        item[this.dataAmountKey] = amount
        item[this.dataStockingAmountKey] = amount

        const storageNumber = getValue(item, `${this.dataGoodsKeepingKey}.storageNumber`)
        if (storageNumber) {
          const _item = storageMap.get(storageNumber)
          self.tableData[_item.index] = item
          self.tableData = this.rowToFrist(self.tableData, _item.index)
          // 同步更新 taskData
          this.syncUpdateTaskData(self.tableData[0], false, self)
          this.setTreeExpand(self)

          haveUpdated = true
        }
      }

      if (!haveUpdated) throw new Error(msg)

      return true
    },
    /**
     * @name 录入模式--有源
     * @description 匹配所有任务只要有 1 条符合，则将扫码信息查询的库存录入到任务明细（无匹配则抛错）
     * @param {vue} self 指向组件 scanStandardPlus 的上下文
     * @param {any[]} [stockData=[]] 库存数据
     * @returns
     */
    modelMatchAndImportForStockOfReunion(self, stockData = []) {
      let msg = '操作失败，超出上游单据商品范围'
      // 校验库存选择器选中的数据合法性
      const newStockData = scanUtils.checkStockData(stockData, this)

      main: for (const stock of newStockData) {
        // 从库存选择器表格中获取数据更新数量
        setValue(this.scanFormData, `${this.dataAmountKey}`, stock[`${this.dataAmountKey}`])
        // 从库存选择器表格中获取数据更新 scanFormData
        scanUtils.updateScanFormDataByStockRow(stock, this)

        console.log('填充到上表的 scanFormData: ', this.scanFormData)
        //如果是编辑则直接填充到上表
        const ifEdit = this.ifEdit(this.scanFormData, true, false, self)
        if (ifEdit) {
          if (ifEdit?.message) throw new Error(ifEdit?.message)
          return { msg: '修改成功' }
        }

        // 转换灵科的结构
        this.linkGoods()

        // 查找上表的任务
        let task = this.seachRows(true, self)
        // 校验是否超出上游单据商品范围
        if (!task || !task.size) throw new Error(msg)

        for (let [, val] of task) {
          let amoutAll = this.amountTotal(val, `item.${this.dataAmountKey}`)
          let planAll = this.amountTotal(val, `item.${this.dataPendingKey}`)
          let nowAmount = calculateUtil.numberAdd(amoutAll, this.scanFormData[this.dataAmountKey])
          let masterRow = this.seachMaster(val, 'item')

          console.log('planAll: ', planAll)
          console.log('nowAmount: ', nowAmount)
          // 所有主从行的数量之和（包括此次扫码的数量） 小于计划数量时，应该将所扫信息填入到该主从行中的某一行或拆行
          if (nowAmount <= planAll) {
            for (let item of val) {
              // 优化线上问题（上海先进）#32410, 校验是否存在相同库存信息的不同商品
              msg = this.checkStorageItemIdAndGoodsId(item.item, this.scanFormData)
              if (msg) continue main

              if (
                !getValue(
                  item.item,
                  this.dataGoodsKeepingKey === 'goodsStore'
                    ? 'goodsStore.storageItemId'
                    : 'storageItem.id'
                )
              ) {
                // 如果扫码的库存信息在对应商品任务明细中为空则赋值到任务明细
                item.item = Object.assign(item.item, this.scanFormData)

                this.store?.dispatch?.('orderBackCountUtil', 'amountBack', item.item, {})
                self.tableData = this.rowToFrist(self.tableData, item.index)
                // 同步更新 taskData
                this.syncUpdateTaskData(self.tableData[0], false, self)
                this.setTreeExpand(self)
                continue main
              } else if (this.checkBatchIsEq(item.item, this.scanFormData)) {
                // 如果扫码的库存信息在对应商品任务明细中一样则进行数量累加
                setValue(
                  item.item,
                  this.dataAmountKey,
                  calculateUtil.numberAdd(
                    getValue(item.item, this.dataAmountKey),
                    getValue(this.scanFormData, this.dataAmountKey)
                  )
                )
                // item.item[this.dataAmountKey] = calculateUtil.numberAdd(
                //   item.item[this.dataAmountKey],
                //   this.scanFormData[this.dataAmountKey]
                // )

                this.store?.dispatch?.('orderBackCountUtil', 'amountBack', item.item, {})
                self.tableData = this.rowToFrist(self.tableData, item.index)
                // 同步更新 taskData
                this.syncUpdateTaskData(self.tableData[0], false, self)
                this.setTreeExpand(self)
                continue main
              }
            }

            // 执行到这里说明应该进行拆行
            let newRow = this.getSplitRow(masterRow.item)
            newRow = Object.assign(newRow, this.scanFormData)
            this.store?.dispatch?.('orderBackCountUtil', 'amountBack', newRow, {})
            self.tableData = [newRow, ...self.tableData]
            // 同步更新 taskData
            this.syncUpdateTaskData(newRow, true, self)
            this.setTreeExpand(self)
            continue main
          } else {
            msg = '操作失败，超出上游单据数量范围'
          }
        }

        throw new Error(msg)
      }

      return true
    },
    /**
     * @name 录入模式--有源
     * @description 匹配所有任务只要有 1 条符合，则将扫码信息查询的库存录入到任务明细（无匹配则抛错）
     * @param {vue} self 指向组件 scanStandardPlus 的上下文
     * @param {any[]} [stockData=[]] 库存数据
     * @returns
     */
    modelMatchAndImportForStockOfLink(self, stockData = []) {
      let msg = '操作失败，超出上游单据商品范围'
      // 校验库存选择器选中的数据合法性
      const newStockData = scanUtils.checkStockData(stockData, this)

      main: for (const stock of newStockData) {
        // 从库存选择器表格中获取数据更新数量
        setValue(this.scanFormData, `${this.dataAmountKey}`, stock[`${this.dataAmountKey}`])
        // 从库存选择器表格中获取数据更新 scanFormData
        scanUtils.updateScanFormDataByStockRow(stock, this)

        console.log('填充到上表的 scanFormData: ', this.scanFormData)
        //如果是编辑则直接填充到上表
        const ifEdit = this.ifEdit(this.scanFormData, true, false, self)
        if (ifEdit) {
          if (ifEdit?.message) throw new Error(ifEdit?.message)
          return { msg: '修改成功' }
        }

        // if (this.scanFormData[this.dataAmountKey] > stock.available) {
        //   msg = '库存不足'
        //   throw new Error(msg)
        // }

        // 转换灵科的结构
        this.linkGoods()

        // 查找上表的任务
        let task = this.seachRows(true, self)
        // 校验是否超出上游单据商品范围
        if (!task || !task.size) throw new Error(msg)

        for (let [, val] of task) {
          let amoutAll = this.amountTotal(val, `item.${this.dataAmountKey}`)
          let planAll = this.amountTotal(val, `item.${this.dataPendingKey}`)
          let nowAmount = calculateUtil.numberAdd(amoutAll, this.scanFormData[this.dataAmountKey])
          let masterRow = this.seachMaster(val, 'item')

          console.log('planAll: ', planAll)
          console.log('nowAmount: ', nowAmount)
          // 所有主从行的数量之和（包括此次扫码的数量） 小于计划数量时，应该将所扫信息填入到该主从行中的某一行或拆行
          if (nowAmount <= planAll) {
            for (let item of val) {
              // 优化线上问题（上海先进）#32410, 校验是否存在相同库存信息的不同商品
              msg = this.checkStorageItemIdAndGoodsId(item.item, this.scanFormData)
              if (msg) continue main

              if (
                !getValue(
                  item.item,
                  this.dataGoodsKeepingKey === 'goodsStore'
                    ? 'goodsStore.storageItemId'
                    : 'storageItem.id'
                )
              ) {
                // 如果扫码的库存信息在对应商品任务明细中为空则赋值到任务明细
                item.item = Object.assign(item.item, this.scanFormData)

                this.store?.dispatch?.('orderBackCountUtil', 'amountBack', item.item, {})
                self.tableData = this.rowToFrist(self.tableData, item.index)
                // 同步更新 taskData
                this.syncUpdateTaskData(self.tableData[0], false, self)
                this.setTreeExpand(self)
                continue main
              } else if (this.checkBatchIsEq(item.item, this.scanFormData)) {
                // 如果扫码的库存信息在对应商品任务明细中一样则进行数量累加
                setValue(
                  item.item,
                  this.dataAmountKey,
                  calculateUtil.numberAdd(
                    getValue(item.item, this.dataAmountKey),
                    getValue(this.scanFormData, this.dataAmountKey)
                  )
                )
                // item.item[this.dataAmountKey] = calculateUtil.numberAdd(
                //   item.item[this.dataAmountKey],
                //   this.scanFormData[this.dataAmountKey]
                // )

                this.store?.dispatch?.('orderBackCountUtil', 'amountBack', item.item, {})
                self.tableData = this.rowToFrist(self.tableData, item.index)
                // 同步更新 taskData
                this.syncUpdateTaskData(self.tableData[0], false, self)
                this.setTreeExpand(self)
                continue main
              }
            }

            // 执行到这里说明应该进行拆行
            let newRow = this.getSplitRow(masterRow.item)
            newRow = Object.assign(newRow, this.scanFormData)
            this.store?.dispatch?.('orderBackCountUtil', 'amountBack', newRow, {})
            self.tableData = [newRow, ...self.tableData]
            // 同步更新 taskData
            this.syncUpdateTaskData(newRow, true, self)
            this.setTreeExpand(self)
            continue main
          } else {
            msg = '操作失败，超出上游单据数量范围'
          }
        }

        throw new Error(msg)
      }

      return true
    },
    /**
     * @name 录入模式--无源
     * @description 匹配所有任务只要有 1 条符合，则将扫码信息查询的库存录入到任务明细（无匹配则抛错）
     * @param {vue} self 指向组件 scanStandardPlus 的上下文
     * @param {any[]} [stockData=[]] 库存数据
     * @returns
     */
    async modelMatchAndImportForStockNoParentOfLink(self, stockData = []) {
      let msg = '操作失败，超出库存数据范围'
      // 校验库存选择器选中的数据合法性
      const newStockData = scanUtils.checkStockData(stockData, this)
      console.log('newStockData: %o', newStockData)

      main: for (const stock of newStockData) {
        // 从库存选择器表格中获取数据更新数量
        setValue(this.scanFormData, `${this.dataAmountKey}`, stock[`${this.dataAmountKey}`])
        // 从库存选择器表格中获取数据更新 scanFormData
        scanUtils.updateScanFormDataByStockRow(stock, this)

        console.log('填充到上表的 scanFormData: ', this.scanFormData)
        //如果是编辑则直接填充到上表
        const ifEdit = this.ifEdit(this.scanFormData, true, false, self)
        if (ifEdit) {
          if (ifEdit?.message) throw new Error(ifEdit?.message)
          return { msg: '修改成功' }
        }

        // 转换灵科的结构
        this.linkGoods()

        // 查找上表的任务
        let task = this.seachRows(true, self)

        for (let [, val] of task) {
          let amoutAll = this.amountTotal(val, `item.${this.dataAmountKey}`)
          let planAll = this.amountTotal(val, `item.${this.dataPendingKey}`)
          let nowAmount = calculateUtil.numberAdd(amoutAll, this.scanFormData[this.dataAmountKey])

          console.log('planAll: ', planAll)
          console.log('nowAmount: ', nowAmount)
          // 所有主从行的数量之和（包括此次扫码的数量） 小于计划数量时，应该将所扫信息填入到该主从行中的某一行或拆行
          if (nowAmount <= planAll) {
            for (let item of val) {
              // 优化线上问题（上海先进）#32410, 校验是否存在相同库存信息的不同商品
              msg = this.checkStorageItemIdAndGoodsId(item.item, this.scanFormData)
              if (msg) continue main

              if (this.checkBatchIsEq(item.item, this.scanFormData)) {
                // 如果扫码的库存信息在对应商品任务明细中一样则进行数量累加
                setValue(
                  item.item,
                  this.dataAmountKey,
                  calculateUtil.numberAdd(
                    getValue(item.item, this.dataAmountKey),
                    getValue(this.scanFormData, this.dataAmountKey)
                  )
                )
                // item.item[this.dataAmountKey] = calculateUtil.numberAdd(
                //   item.item[this.dataAmountKey],
                //   this.scanFormData[this.dataAmountKey]
                // )

                this.store?.dispatch?.('orderBackCountUtil', 'amountBack', item.item, {})
                self.tableData = this.rowToFrist(self.tableData, item.index)
                self.tableData[0] = Object.assign(stock, self.tableData[0])
                // 同步更新 taskData
                this.syncUpdateTaskData(self.tableData[0], false, self)
                this.setTreeExpand(self)
                continue main
              }
            }
          } else {
            throw new Error(msg)
          }
        }

        // 执行到这里说明应该新增
        const newRow = Object.assign(stock, this.scanFormData)
        console.log('newRow: %o', newRow)
        console.log('scanFormData: %o', this.scanFormData)
        newRow.plan = stock.available

        this.store?.dispatch?.('orderBackCountUtil', 'amountBack', newRow, {})
        self.tableData = [newRow, ...self.tableData]
        // 同步更新 taskData
        this.syncUpdateTaskData(newRow, true, self)
        this.setTreeExpand(self)
        continue main
      }

      return true
    },
    /**
     * @name 录入模式--无源
     * @description 匹配所有任务只要有 1 条符合，则将扫码信息查询的库存录入到任务明细（应用于：调拨单）
     * @param {vue} self 指向组件 scanStandardPlus 的上下文
     * @param {any[]} [stockData=[]] 库存数据
     * @returns
     */
    async modelMatchAndImportForStockNoParent(self, stockData = [], { formData }) {
      let msg = '操作失败，超出库存数据范围'
      // 校验库存选择器选中的数据合法性
      const newStockData = scanUtils.checkStockData(stockData, this)

      main: for (const stock of newStockData) {
        // 从库存选择器表格中获取数据更新数量
        setValue(this.scanFormData, `${this.dataAmountKey}`, stock[`${this.dataAmountKey}`])
        // 从库存选择器表格中获取数据更新 scanFormData
        scanUtils.updateScanFormDataByStockRow(stock, this)

        console.log('填充到上表的 scanFormData: ', this.scanFormData)
        //如果是编辑则直接填充到上表
        const ifEdit = this.ifEdit(this.scanFormData, true, false, self)
        if (ifEdit) {
          if (ifEdit?.message) throw new Error(ifEdit?.message)
          return { msg: '修改成功' }
        }

        // 查找上表的任务
        let task = this.seachRows(true, self)

        for (let [, val] of task) {
          for (let item of val) {
            // 优化线上问题（上海先进）#32410, 校验是否存在相同库存信息的不同商品
            msg = this.checkStorageItemIdAndGoodsId(item.item, this.scanFormData)
            if (msg) continue main

            if (this.checkBatchIsEq(item.item, this.scanFormData)) {
              // 如果扫码的库存信息在对应商品任务明细中一样则进行数量累加
              setValue(
                item.item,
                this.dataAmountKey,
                calculateUtil.numberAdd(
                  getValue(item.item, this.dataAmountKey),
                  getValue(this.scanFormData, this.dataAmountKey)
                )
              )
              // item.item[this.dataAmountKey] = calculateUtil.numberAdd(
              //   item.item[this.dataAmountKey],
              //   this.scanFormData[this.dataAmountKey]
              // )

              this.store?.dispatch?.('orderBackCountUtil', 'amountBack', item.item, {})
              this.store?.dispatch?.('orderBackCountUtil', 'orderDiscountsTotalFn', formData) //计算折扣金额总计
              self.tableData = this.rowToFrist(self.tableData, item.index)
              // 同步更新 taskData
              this.syncUpdateTaskData(self.tableData[0], false, self)
              this.setTreeExpand(self)
              continue main
            }
          }
        }

        // 执行到这里说明应该新增
        let newRow
        // 获取添加的数据结构
        if (self.createItemOfParams) {
          setValue(self.createItemOfParams, 'parameters.codes', [
            ...new Set(newStockData.map((item) => getValue(item, `${this.dataGoodsInfoKey}.code`))),
          ])
        }
        const createResData = await this.createItem({ ...self.createItemOfParams })
        if (createResData?.length) {
          const item = createResData?.[0] || {}
          console.log('createResData: ', item)
          console.log('stock: ', stock)
          newRow = Object.assign(item, this.scanFormData)
        }
        console.log('newRow: ', newRow)

        this.store?.dispatch?.('orderBackCountUtil', 'amountBack', newRow, {})
        this.store?.dispatch?.('orderBackCountUtil', 'orderDiscountsTotalFn', formData) //计算折扣金额总计
        self.tableData = [newRow, ...self.tableData]
        // 同步更新 taskData
        this.syncUpdateTaskData(newRow, true, self)
        this.setTreeExpand(self)
        continue main
      }

      return true
    },
    /**
     * @name 匹配模式-有源
     * @description 通过所扫商品与任务明细进行匹配（字段：商品id、批号），匹配成功则累加数量，否则匹配最近的商品和批号相同进行拆行
     * @param {vue} self 指向组件 scanStandardPlus 的上下文
     * @param {boolean} split 是否可拆行
     */
    modelCheckoutAmount(self, split = false) {
      let msg = '操作失败，超出上游单据商品范围'
      // const { data: scanData } = this.scanResult
      console.log(
        '通过所扫商品与任务明细进行匹配（字段：商品id、批号），匹配成功则累加数量，否则匹配最近的商品和批号相同进行拆行'
      )
      console.log('填充到上表的 scanFormData: ', this.scanFormData)
      // 是否是编辑，只判断不执行修改
      let ifEdit = this.ifEdit(this.scanFormData, true, true, self, true)

      // 查找上表的任务
      let task = this.seachRows(true, self)
      // 校验是否超出上游单据商品范围
      if (!task || !task.size) throw new Error(msg)

      main: for (let [, val] of task) {
        let amoutAll = this.amountTotal(val, `item.${this.dataAmountKey}`)
        let planAll = this.amountTotal(val, `item.${this.dataPendingKey}`)
        let nowAmount = ifEdit
          ? this.scanFormData[this.dataAmountKey]
          : calculateUtil.numberAdd(amoutAll, this.scanFormData[this.dataAmountKey])
        let masterRow = this.seachMaster(val, 'item')

        console.log('planAll: ', planAll)
        console.log('nowAmount: ', nowAmount)

        child: for (let item of val) {
          // const checkArr = [
          //   `${this.dataGoodsInfoKey}.id`,
          //   `${this.dataGoodsKeepingKey}.periodBegin`,
          //   `${this.dataGoodsKeepingKey}.batchNumber`,
          // ]
          const checkArr = this.setCheckArr()

          // #6553
          const ifSerial = scanUtils.ifSerial(
            this.scanFormData,
            `${this.dataGoodsInfoKey}.keepingSerial`
          )

          if (ifSerial) {
            checkArr.push(`${this.dataGoodsKeepingKey}.serialNumber`)
          }

          console.log('checkArr: ', checkArr)
          if (
            this.type === 'epc'
              ? scanUtils.checkEpcIsEq(item.item, this)
              : this.checkGoodAndBatchIsEq(item.item, this.scanFormData, checkArr)
          ) {
            // 是否是编辑，会执行修改
            ifEdit = this.ifEdit(this.scanFormData, false, true, self)
            if (ifEdit) {
              if (ifEdit?.message) throw new Error(ifEdit?.message)
              return { msg: '修改成功' }
            }
            const amountRow = calculateUtil.numberAdd(
              getValue(item.item, this.dataAmountKey),
              getValue(this.scanFormData, this.dataAmountKey)
            )
            // const amountRow = calculateUtil.numberAdd(
            //   item.item[this.dataAmountKey],
            //   this.scanFormData[this.dataAmountKey]
            // )
            const planRow = getValue(item.item, `${this.dataPendingKey}`)
            console.log('amountRow: ', amountRow)
            console.log('planRow: ', planRow)
            // 所有主从行的数量之和（包括此次扫码的数量） 小于计划数量时，应该将所扫信息填入到该主从行中的某一行或拆行
            if (nowAmount > planAll) {
              msg = '已超出待处理数量'
              continue main
            }
            // 校验每行的数量是否小于当前行的计划数量
            if (amountRow > planRow) {
              msg = '已超出待处理数量'
              continue child
            }

            // 如果扫码获取到厂家原始条码，则将 originBarCode 和 originBarCodeDisplay 赋值到任务明细中
            this.setOriginBarCode(item.item)

            // 累加数量
            setValue(
              item.item,
              this.dataAmountKey,
              calculateUtil.numberAdd(
                getValue(this.scanFormData, this.dataAmountKey),
                getValue(item.item, this.dataAmountKey)
              )
            )
            item.item.scanMethod = 'SCAN' // #9818
            // item.item[this.dataAmountKey] = calculateUtil.numberAdd(
            //   this.scanFormData[this.dataAmountKey],
            //   item.item[this.dataAmountKey]
            // )

            this.store?.dispatch?.('orderBackCountUtil', 'amountBack', item.item, {})
            self.tableData = this.rowToFrist(self.tableData, item.index)
            // 同步更新 taskData
            this.syncUpdateTaskData(self.tableData[0], false, self)
            this.setTreeExpand(self)
            return true
          }
        }

        // 匹配最近的商品和批号相同进行拆行
        if (
          split &&
          this.checkRowAndSelectBatchIsEq(
            masterRow.item,
            this.scanFormData[this.dataGoodsKeepingKey]
          ) &&
          this.checkGoodAndBatchIsEq(masterRow.item, this.scanFormData, [
            'batchNumber',
            'serialNumber',
          ])
        ) {
          // 所有主从行的数量之和（包括此次扫码的数量） 小于计划数量时，应该将所扫信息填入到该主从行中的某一行或拆行
          if (nowAmount > planAll) {
            msg = '已超出待处理数量'
            continue main
          }

          let newRow = this.getSplitRow(masterRow.item)
          newRow[this.dataAmountKey] = this.scanFormData[this.dataAmountKey]
          newRow[this.dataGoodsKeepingKey] = this.scanFormData[this.dataGoodsKeepingKey]
          newRow.scanMethod = 'SCAN' // #9818

          // 如果扫码获取到厂家原始条码，则将 originBarCode 和 originBarCodeDisplay 赋值到任务明细中
          this.setOriginBarCode(newRow)

          this.store?.dispatch?.('orderBackCountUtil', 'amountBack', newRow, {})
          self.tableData = [newRow, ...self.tableData]
          // 同步更新 taskData
          this.syncUpdateTaskData(newRow, true, self)
          this.setTreeExpand(self)

          return true
        }
      }

      if (!split) {
        return this.modelCheckoutAmount(self, true)
      }

      throw new Error(msg)
    },

    /**
     * @name 匹配模式-有源
     * @description 通过字段 Rfid 拆分明细，并将数量赋值为1
     * @param {vue} self 指向组件 scanStandardPlus 的上下文
     * @param {vue} rfids 待绑定的 rfid 条码
     * @param {boolean} split 是否可拆行
     */
    modelCheckoutAmountForRfid(self, rfids, split = false) {
      let msg = '操作失败，超出上游单据商品范围'
      console.log('通过字段 Rfid 拆分明细，并将数量赋值为1', rfids)
      console.log('填充到上表的 scanFormData: ', this.scanFormData)
      // 是否是编辑，只判断不执行修改
      let ifEdit = this.ifEdit(this.scanFormData, true, true, self, true)

      // 查找上表的任务
      let task = this.seachRows(true, self)
      // 校验是否超出上游单据商品范围
      if (!task || !task.size) throw new Error('操作失败，超出上游单据商品范围')

      // 更新epcs
      const updateEpcs = (row) => {
        if (!row.epcs) row.epcs = []
        if (rfids?.length) {
          row[this.dataGoodsKeepingKey].epc = null // 需要重置字段 epc 的值，否则在后续提交中接口会报错
          row.epcs = [...new Set([...row.epcs, ...rfids])]
        }
      }

      // 校验 rfid 条码是否重复
      if (this.checkRfidIsReapt(task, rfids)) {
        msg = '该RFID标签已使用'
      } else {
        main: for (let [, val] of task) {
          let amoutAll = this.amountTotal(val, `item.${this.dataAmountKey}`)
          let planAll = this.amountTotal(val, `item.${this.dataPendingKey}`)
          let nowAmount = ifEdit
            ? this.scanFormData[this.dataAmountKey]
            : calculateUtil.numberAdd(amoutAll, this.scanFormData[this.dataAmountKey])
          let masterRow = this.seachMaster(val, 'item')

          console.log('planAll: ', planAll)
          console.log('nowAmount: ', nowAmount)

          child: for (let item of val) {
            const checkArr = this.setCheckArr()
            const ifSerial = scanUtils.ifSerial(
              this.scanFormData,
              `${this.dataGoodsInfoKey}.keepingSerial`
            )
            if (ifSerial) checkArr.push(`${this.dataGoodsKeepingKey}.serialNumber`)

            // 查找上表的任务
            const checkTask = this.seachRows(true, self)
            if (this.checkRfidIsReapt(checkTask, rfids)) {
              msg = '该RFID标签已使用'
              break main // 此时有重复说明：明细中存在多条批号、商品ID相同的数据，直接忽略
            }

            if (this.checkGoodAndBatchIsEq(item.item, this.scanFormData, checkArr)) {
              // 是否是编辑，会执行修改
              ifEdit = this.ifEdit(this.scanFormData, false, true, self)
              if (ifEdit) {
                if (ifEdit?.message) throw new Error(ifEdit?.message)
                return { msg: '修改成功' }
              }
              const amountRow = calculateUtil.numberAdd(
                getValue(item.item, this.dataAmountKey),
                getValue(this.scanFormData, this.dataAmountKey)
              )
              // const amountRow = calculateUtil.numberAdd(
              //   item.item[this.dataAmountKey],
              //   this.scanFormData[this.dataAmountKey]
              // )
              const planRow = getValue(item.item, `${this.dataPendingKey}`)
              console.log('amountRow: ', amountRow)
              console.log('planRow: ', planRow)
              // 所有主从行的数量之和（包括此次扫码的数量） 小于计划数量时，应该将所扫信息填入到该主从行中的某一行或拆行
              if (nowAmount > planAll) {
                msg = '操作失败，超出上游单据数量范围'
                continue main
              }
              // 校验每行的数量是否小于当前行的计划数量
              if (amountRow > planRow) {
                msg = '操作失败，超出上游单据数量范围'
                continue child
              }

              // 如果扫码获取到厂家原始条码，则将 originBarCode 和 originBarCodeDisplay 赋值到任务明细中
              this.setOriginBarCode(item.item)

              // 累加数量
              setValue(item.item, this.dataAmountKey, amountRow)
              // item.item[this.dataAmountKey] = amountRow

              // 更新epcs
              updateEpcs(item.item)

              this.store?.dispatch?.('orderBackCountUtil', 'amountBack', item.item, {})
              self.tableData = this.rowToFrist(self.tableData, item.index)
              // 同步更新 taskData
              this.syncUpdateTaskData(self.tableData[0], true, self)
              this.setTreeExpand(self)

              return true
            }
          }

          // 查找上表的任务
          const checkTask = this.seachRows(true, self)
          if (this.checkRfidIsReapt(checkTask, rfids)) {
            msg = '该RFID标签已使用'
            break main // 此时有重复说明：明细中存在多条批号、商品ID相同的数据，直接忽略
          }

          // 匹配最近的商品和批号相同进行拆行
          if (
            split &&
            this.checkRowAndSelectBatchIsEq(
              masterRow.item,
              this.scanFormData[this.dataGoodsKeepingKey]
            ) &&
            this.checkGoodAndBatchIsEq(masterRow.item, this.scanFormData, [
              'batchNumber',
              'serialNumber',
            ])
          ) {
            // 所有主从行的数量之和（包括此次扫码的数量） 小于计划数量时，应该将所扫信息填入到该主从行中的某一行或拆行
            if (nowAmount > planAll) {
              msg = '操作失败，超出上游单据数量范围'
              continue main
            }

            let newRow = this.getSplitRow(masterRow.item)
            newRow[this.dataAmountKey] = this.scanFormData[this.dataAmountKey]
            newRow[this.dataGoodsKeepingKey] = this.scanFormData[this.dataGoodsKeepingKey]

            // 更新epcs
            updateEpcs(newRow)

            // 如果扫码获取到厂家原始条码，则将 originBarCode 和 originBarCodeDisplay 赋值到任务明细中
            this.setOriginBarCode(newRow)

            this.store?.dispatch?.('orderBackCountUtil', 'amountBack', newRow, {})
            self.tableData = [newRow, ...self.tableData]
            // 同步更新 taskData
            this.syncUpdateTaskData(newRow, true, self)
            this.setTreeExpand(self)

            return true
          }
        }
      }

      if (!split) {
        return this.modelCheckoutAmountForRfid(self, rfids, true)
      }

      throw new Error(msg)
    },
    /**
     * @name 匹配模式-有源
     * @description 通过所扫商品与任务明细进行匹配（字段：商品id、批号），匹配成功则累加数量，否则匹配最近的商品和批号相同进行拆行
     * @param {vue} self 指向组件 scanStandardPlus 的上下文
     */
    modelCheckoutAndNoAmount(self) {
      let msg = '操作失败，超出上游单据商品范围'
      // const { data: scanData } = this.scanResult
      console.log(
        '通过所扫商品与任务明细进行匹配（字段：商品id、批号），匹配成功则累加数量，否则匹配最近的商品和批号相同进行拆行'
      )
      console.log('填充到上表的 scanFormData: ', this.scanFormData)
      // 是否是编辑，只判断不执行修改
      let ifEdit = this.ifEdit(this.scanFormData, true, true, self, true)

      // 查找上表的任务
      let task = this.seachRows(true, self)
      // 校验是否超出上游单据商品范围
      if (!task || !task.size) throw new Error(msg)

      main: for (let [, val] of task) {
        let amoutAll = this.amountTotal(val, `item.${this.dataAmountKey}`)
        let planAll = this.amountTotal(val, `item.${this.dataPendingKey}`)
        let nowAmount = ifEdit
          ? this.scanFormData[this.dataAmountKey]
          : calculateUtil.numberAdd(amoutAll, this.scanFormData[this.dataAmountKey])
        // let masterRow = this.seachMaster(val, 'item')

        console.log('planAll: ', planAll)
        console.log('nowAmount: ', nowAmount)

        child: for (let item of val) {
          // const checkArr = [
          //   `${this.dataGoodsInfoKey}.id`,
          //   `${this.dataGoodsKeepingKey}.periodBegin`,
          //   `${this.dataGoodsKeepingKey}.batchNumber`,
          // ]
          const checkArr = this.setCheckArr()
          const ifSerial = scanUtils.ifSerial(
            this.scanFormData,
            `${this.dataGoodsInfoKey}.keepingSerial`
          )
          if (ifSerial) checkArr.push(`${this.dataGoodsKeepingKey}.serialNumber`)

          if (
            this.type === 'epc'
              ? scanUtils.checkEpcIsEq(item.item, this)
              : this.checkGoodAndBatchIsEq(item.item, this.scanFormData, checkArr)
          ) {
            // 是否是编辑，会执行修改
            ifEdit = this.ifEdit(this.scanFormData, false, true, self)
            if (ifEdit) {
              if (ifEdit?.message) throw new Error(ifEdit?.message)
              return { msg: '修改成功' }
            }
            const amountRow = calculateUtil.numberAdd(
              getValue(item.item, this.dataAmountKey),
              getValue(this.scanFormData, this.dataAmountKey)
            )
            // const amountRow = calculateUtil.numberAdd(
            //   item.item[this.dataAmountKey],
            //   this.scanFormData[this.dataAmountKey]
            // )
            const planRow = getValue(item.item, `${this.dataPendingKey}`)
            console.log('amountRow: ', amountRow)
            console.log('planRow: ', planRow)
            // 所有主从行的数量之和（包括此次扫码的数量） 小于计划数量时，应该将所扫信息填入到该主从行中的某一行或拆行
            if (nowAmount > planAll) {
              msg = '操作失败，超出上游单据数量范围'
              continue main
            }
            // 校验每行的数量是否小于当前行的计划数量
            if (amountRow > planRow) {
              msg = '操作失败，超出上游单据数量范围'
              continue child
            }

            // 如果扫码获取到厂家原始条码，则将 originBarCode 和 originBarCodeDisplay 赋值到任务明细中
            this.setOriginBarCode(item.item)

            // 累加数量
            setValue(
              item.item,
              this.dataAmountKey,
              calculateUtil.numberAdd(
                getValue(this.scanFormData, this.dataAmountKey),
                getValue(item.item, this.dataAmountKey)
              )
            )
            // item.item[this.dataAmountKey] = calculateUtil.numberAdd(
            //   this.scanFormData[this.dataAmountKey],
            //   item.item[this.dataAmountKey]
            // )

            this.store?.dispatch?.('orderBackCountUtil', 'amountBack', item.item, {})
            self.tableData = this.rowToFrist(self.tableData, item.index)
            // 同步更新 taskData
            this.syncUpdateTaskData(self.tableData[0], false, self)
            this.setTreeExpand(self)
            return true
          }
        }

        // 匹配最近的商品和批号相同进行拆行
        // if (
        //   split &&
        //   this.checkRowValIsEq(masterRow.item, scanData, ['batchNumber', 'serialNumber'])
        // ) {
        //   // 所有主从行的数量之和（包括此次扫码的数量） 小于计划数量时，应该将所扫信息填入到该主从行中的某一行或拆行
        //   if (nowAmount > planAll) {
        //     msg = '操作失败，超出上游单据数量范围'
        //     continue main
        //   }

        //   let newRow = this.getSplitRow(masterRow.item)
        //   // newRow[this.dataAmountKey] = this.scanFormData[this.dataAmountKey]
        //   newRow[this.dataGoodsKeepingKey] = this.scanFormData[this.dataGoodsKeepingKey]

        //   // 如果扫码获取到厂家原始条码，则将 originBarCode 和 originBarCodeDisplay 赋值到任务明细中
        //   this.setOriginBarCode(newRow)

        //   this.store?.dispatch?.('orderBackCountUtil', 'amountBack', newRow, {})
        //   self.tableData = [newRow, ...self.tableData]
        //   // 同步更新 taskData
        //   this.syncUpdateTaskData(newRow, true, self)
        //   this.setTreeExpand(self)

        //   return true
        // }
      }

      // if (!split) {
      //   return this.modelCheckoutAmount(self, true)
      // }

      throw new Error(msg)
    },
    /**
     * @name 匹配模式-有源
     * @description 通过所扫商品与任务明细进行匹配（字段：商品id、批号），匹配成功则累加数量，如果未匹配成功则提示报错（不拆行）
     * @param {vue} self 指向组件 scanStandardPlus 的上下文
     *
     */
    modelCheckoutAmountNoSplit(self, data) {
      let msg = '操作失败，超出上游单据商品范围'
      console.log(
        '通过所扫商品与任务明细进行匹配（字段：商品id、批号），匹配成功则累加数量，如果未匹配成功则提示报错（不拆行）'
      )
      console.log('填充到上表的 scanFormData: ', this.scanFormData)
      // 是否是编辑，只判断不执行修改
      let ifEdit = this.ifEdit(this.scanFormData, true, true, self, true)
      // 库存业态是否是定数包
      const isNumberPackage = getValue(this.scanFormData, 'isNumberPackage')
      console.log('isNumberPackage: ', isNumberPackage, data?.[0]?.amountOut)

      // 查找上表的任务
      let task = this.seachRows(true, self)
      // 校验是否超出上游单据商品范围
      if (!task || !task.size) throw new Error(msg)

      main: for (let [, val] of task) {
        let amoutAll = this.amountTotal(val, `item.${this.dataAmountKey}`)
        let planAll = this.amountTotal(val, `item.${this.dataPendingKey}`)
        let nowAmount = ifEdit
          ? this.scanFormData[this.dataAmountKey]
          : calculateUtil.numberAdd(amoutAll, this.scanFormData[this.dataAmountKey])

        if (isNumberPackage && data?.[0]?.amountOut) {
          nowAmount = data?.[0]?.amountOut
        }

        child: for (let item of val) {
          // const checkArr = [
          //   `${this.dataGoodsInfoKey}.id`,
          //   `${this.dataGoodsKeepingKey}.periodBegin`,
          //   `${this.dataGoodsKeepingKey}.batchNumber`,
          // ]
          const checkArr = this.setCheckArr()
          const ifSerial = scanUtils.ifSerial(
            this.scanFormData,
            `${this.dataGoodsInfoKey}.keepingSerial`
          )
          if (ifSerial) checkArr.push(`${this.dataGoodsKeepingKey}.serialNumber`)

          if (
            this.type === 'epc'
              ? scanUtils.checkEpcIsEq(item.item, this)
              : this.checkGoodAndBatchIsEq(item.item, this.scanFormData, checkArr)
          ) {
            // 是否是编辑，会执行修改
            ifEdit = this.ifEdit(this.scanFormData, false, true, self)
            if (ifEdit) {
              if (ifEdit?.message) throw new Error(ifEdit?.message)
              return { msg: '修改成功' }
            }
            let amountRow = 0
            if (isNumberPackage && data?.[0]?.amountOut) {
              amountRow = data?.[0]?.amountOut
            } else {
              amountRow = calculateUtil.numberAdd(
                getValue(item.item, this.dataAmountKey),
                getValue(this.scanFormData, this.dataAmountKey)
              )
              // amountRow = calculateUtil.numberAdd(
              //   item.item[this.dataAmountKey],
              //   this.scanFormData[this.dataAmountKey]
              // )
            }
            const planRow = getValue(item.item, `${this.dataPendingKey}`)

            console.log('amountRow: ', amountRow)
            console.log('planRow: ', planRow)
            // 所有主从行的数量之和（包括此次扫码的数量） 小于计划数量时，应该将所扫信息填入到该主从行中的某一行或拆行
            if (nowAmount > planAll) {
              msg = '操作失败，超出上游单据数量范围'
              continue main
            }
            // 校验每行的数量是否小于当前行的计划数量
            if (amountRow > planRow) {
              msg = '操作失败，超出上游单据数量范围'
              continue child
            }

            // 如果扫码获取到厂家原始条码，则将 originBarCode 和 originBarCodeDisplay 赋值到任务明细中
            this.setOriginBarCode(item.item)

            // 累加数量
            if (isNumberPackage && data?.[0]?.amountOut) {
              setValue(item.item, this.dataAmountKey, data?.[0]?.amountOut)
              // item.item[this.dataAmountKey] = data?.[0]?.amountOut
            } else {
              setValue(
                item.item,
                this.dataAmountKey,
                calculateUtil.numberAdd(
                  getValue(this.scanFormData, this.dataAmountKey),
                  getValue(item.item, this.dataAmountKey)
                )
              )
              // item.item[this.dataAmountKey] = calculateUtil.numberAdd(
              //   this.scanFormData[this.dataAmountKey],
              //   item.item[this.dataAmountKey]
              // )
            }

            this.store?.dispatch?.('orderBackCountUtil', 'amountBack', item.item, {})
            self.tableData = this.rowToFrist(self.tableData, item.index)
            // 同步更新 taskData
            this.syncUpdateTaskData(self.tableData[0], false, self)
            this.setTreeExpand(self)
            return true
          }
        }
      }

      throw new Error(msg)
    },

    /**
     * @name 匹配模式-有源
     * @description 通过所扫商品与任务明细进行匹配（字段：商品id、批号），匹配成功则累加数量，如果未匹配成功则提示报错（不拆行）
     * @param {vue} self 指向组件 scanStandardPlus 的上下文
     *
     */
    checkGoodNumber(self, data, store) {
      let msg = '操作失败，未匹配到商品'
      console.log(
        '通过商品编码进行匹配 如果匹配到就直接将数据添加到上表，如果未匹配成功则提示报错（不拆行）'
      )
      console.log('填充到上表的 scanFormData: ', this.scanFormData)
      let ifEdit = this.ifEdit(this.scanFormData, true, true, self, true)
      // 查找上表的任务
      let task = this.seachRows(true, self)
      // 校验是否超出上游单据商品范围
      if (!task || !task.size) throw new Error(msg)
      //判断数量是否超过上游
      let splitRow = null
      for (let [, val] of task) {
        let amoutAll = this.amountTotal(val, `item.${this.dataAmountKey}`)
        let planAll = this.amountTotal(val, `item.${this.dataPendingKey}`)
        console.log('planAll: ', planAll)
        console.log('amoutAll: ', amoutAll)

        if (amoutAll == planAll && !ifEdit) {
          throw new Error('已经超过总数')
        }

        for (let elem of val) {
          if (
            getValue(elem.item, `${this.dataGoodsInfoKey}.code`) ===
            getValue(this.scanFormData, `${this.dataGoodsInfoKey}.code`)
          ) {
            if (amoutAll < planAll && elem.item[this.dataAmountKey]) {
              splitRow = JSON.parse(JSON.stringify(elem.item))
              //主行master强制置为false,计划数量置为null
              splitRow.plan = null
              splitRow.planDisplay = null
              splitRow.master = false
              splitRow.id = null
              splitRow.item = 0
              // splitRow.amount = 0
              splitRow.amountDisplay = 1 //
              splitRow._ID = objectUtil.createID()
              this.store?.dispatch?.('orderBackCountUtil', 'amountDisplay', splitRow, {})
            }

            if (ifEdit && this.scanFormData?._ID == elem?.item?._ID) {
              setValue(
                elem.item,
                `${this.dataGoodsKeepingKey}.batchNumber`,
                getValue(this.scanFormData, `${this.dataGoodsKeepingKey}.batchNumber`)
              )
              setValue(
                elem.item,
                `${this.dataGoodsKeepingKey}.serialNumber`,
                getValue(this.scanFormData, `${this.dataGoodsKeepingKey}.serialNumber`)
              )
              setValue(
                elem.item,
                `${this.dataGoodsKeepingKey}.periodBegin`,
                getValue(this.scanFormData, `${this.dataGoodsKeepingKey}.periodBegin`)
              )
              setValue(
                elem.item,
                `${this.dataGoodsKeepingKey}.periodEnd`,
                getValue(this.scanFormData, `${this.dataGoodsKeepingKey}.periodEnd`)
              )
              setValue(
                elem.item,
                `${this.dataGoodsKeepingKey}.registration`,
                getValue(this.scanFormData, `${this.dataGoodsKeepingKey}.registration`)
              )
              setValue(
                elem.item,
                `${this.dataGoodsKeepingKey}.certification`,
                getValue(this.scanFormData, `${this.dataGoodsKeepingKey}.certification`)
              )
              setValue(
                elem.item,
                `${this.dataGoodsKeepingKey}.originBarCodeDisplay`,
                getValue(this.scanFormData, `${this.dataGoodsKeepingKey}.originBarCodeDisplay`)
              )
              //生产企业
              //判断注册证里面是否有生产企业 有就取 没有的话就取商品信息的
              let manufacturer = getValue(
                this.scanFormData,
                `${this.dataGoodsKeepingKey}.manufacturerName`
              )
                ? getValue(this.scanFormData, `${this.dataGoodsKeepingKey}.manufacturerName`)
                : getValue(this.scanFormData, `${this.dataGoodsInfoKey}.manufacturer.name`)
              setValue(elem.item, `${this.dataGoodsInfoKey}.manufacturerName`, manufacturer)
              setValue(elem.item, '._isMatch', true)
              break
            } else {
              setValue(
                elem.item,
                `${this.dataGoodsKeepingKey}.batchNumber`,
                getValue(this.scanFormData, `${this.dataGoodsKeepingKey}.batchNumber`)
              )
              setValue(
                elem.item,
                `${this.dataGoodsKeepingKey}.serialNumber`,
                getValue(this.scanFormData, `${this.dataGoodsKeepingKey}.serialNumber`)
              )
              setValue(
                elem.item,
                `${this.dataGoodsKeepingKey}.periodBegin`,
                getValue(this.scanFormData, `${this.dataGoodsKeepingKey}.periodBegin`)
              )
              setValue(
                elem.item,
                `${this.dataGoodsKeepingKey}.periodEnd`,
                getValue(this.scanFormData, `${this.dataGoodsKeepingKey}.periodEnd`)
              )
              setValue(
                elem.item,
                `${this.dataGoodsKeepingKey}.registration`,
                getValue(this.scanFormData, `${this.dataGoodsKeepingKey}.registration`)
              )
              setValue(
                elem.item,
                `${this.dataGoodsKeepingKey}.certification`,
                getValue(this.scanFormData, `${this.dataGoodsKeepingKey}.certification`)
              )
              setValue(
                elem.item,
                `${this.dataGoodsKeepingKey}.originBarCodeDisplay`,
                getValue(this.scanFormData, `${this.dataGoodsKeepingKey}.originBarCodeDisplay`)
              )
              //生产企业
              //判断注册证里面是否有生产企业 有就取 没有的话就取商品信息的
              let manufacturer = getValue(
                this.scanFormData,
                `${this.dataGoodsKeepingKey}.manufacturerName`
              )
                ? getValue(this.scanFormData, `${this.dataGoodsKeepingKey}.manufacturerName`)
                : getValue(this.scanFormData, `${this.dataGoodsInfoKey}.manufacturer.name`)
              setValue(elem.item, `${this.dataGoodsInfoKey}.manufacturerName`, manufacturer)
              setValue(elem.item, `${this.dataAmountKey}`, 1)
              setValue(elem.item, '._isMatch', true)
              this.store?.dispatch?.('orderBackCountUtil', 'amountDisplay', elem.item, {})
            }

            //return true
          } else {
            throw new Error(msg)
          }
        }
      }
      if (splitRow) {
        self.tableData.splice(self.tableData.length, 0, splitRow)
      }
      store.states.formData.items = self.tableData
      store.commit('tableRefresh', true)
    },
    /**
     * @name 匹配模式-有源
     * @description 通过所扫商品与任务明细进行匹配（字段：商品id、批号等商品信息），匹配成功则累加数量，如果未匹配成功则提示报错（不拆行）
     * @param {vue} self 指向组件 scanStandardPlus 的上下文
     *
     */
    modelCheckoutAmountNoSplitAndNoParent(self) {
      let msg = '操作失败，超出上游单据商品范围'
      // const { data: scanData } = this.scanResult
      console.log(
        '通过所扫商品与任务明细进行匹配（字段：商品id、批号等商品信息），匹配成功则累加数量，如果未匹配成功则提示报错（不拆行）'
      )
      console.log('填充到上表的 scanFormData: ', this.scanFormData)
      // 是否是编辑，只判断不执行修改
      let ifEdit = this.ifEdit(this.scanFormData, true, true, self, true)

      // 查找上表的任务
      let task = this.seachRows(false, self)
      // 校验是否超出上游单据商品范围
      if (!task || !task.size) throw new Error(msg)

      main: for (let [tIndex, _val] of task) {
        const val = Array.isArray(_val) ? _val : [{ index: tIndex, item: _val }]
        let amoutAll = this.amountTotal(val, `item.${this.dataAmountKey}`)
        let planAll = this.amountTotal(val, `item.${this.dataPendingKey}`)
        let nowAmount = ifEdit
          ? this.scanFormData[this.dataAmountKey]
          : calculateUtil.numberAdd(amoutAll, this.scanFormData[this.dataAmountKey])

        console.log('planAll: ', planAll)
        console.log('nowAmount: ', nowAmount)

        child: for (let item of val) {
          // const checkArr = [
          //   `${this.dataGoodsInfoKey}.id`,
          //   `${this.dataGoodsKeepingKey}.periodBegin`,
          //   `${this.dataGoodsKeepingKey}.batchNumber`,
          // ]
          const checkArr = this.setCheckArr()
          const ifSerial = scanUtils.ifSerial(
            this.scanFormData,
            `${this.dataGoodsInfoKey}.keepingSerial`
          )
          if (ifSerial) checkArr.push(`${this.dataGoodsKeepingKey}.serialNumber`)

          if (
            (this.checkRowAndSelectBatchIsEq(
              item.item,
              this.scanFormData[this.dataGoodsKeepingKey]
            ) &&
              this.checkGoodAndBatchIsEq(item.item, this.scanFormData, checkArr)) ||
            (this.$parent.currentSelected === 'epc' &&
              getValue(item.item, `${this.dataGoodsKeepingKey}.epc`) === this.scanResult.origin &&
              this.checkGoodsIsEq(item.item, this.scanFormData))
          ) {
            // 是否是编辑，会执行修改
            ifEdit = this.ifEdit(this.scanFormData, false, true, self)
            if (ifEdit) {
              if (ifEdit?.message) throw new Error(ifEdit?.message)
              return { msg: '修改成功' }
            }
            const amountRow = calculateUtil.numberAdd(
              getValue(item.item, this.dataAmountKey),
              getValue(this.scanFormData, this.dataAmountKey)
            )
            // const amountRow = calculateUtil.numberAdd(
            //   item.item[this.dataAmountKey],
            //   this.scanFormData[this.dataAmountKey]
            // )
            const planRow = getValue(item.item, `${this.dataPendingKey}`)
            console.log('amountRow: ', amountRow)
            console.log('planRow: ', planRow)
            // 所有主从行的数量之和（包括此次扫码的数量） 小于计划数量时，应该将所扫信息填入到该主从行中的某一行或拆行
            if (nowAmount > planAll) {
              msg = '操作失败，超出上游单据数量范围'
              continue main
            }
            // 校验每行的数量是否小于当前行的计划数量
            if (amountRow > planRow) {
              msg = '操作失败，超出上游单据数量范围'
              continue child
            }

            // 如果扫码获取到厂家原始条码，则将 originBarCode 和 originBarCodeDisplay 赋值到任务明细中
            this.setOriginBarCode(item.item)

            // 累加数量
            setValue(
              item.item,
              this.dataAmountKey,
              calculateUtil.numberAdd(
                getValue(this.scanFormData, this.dataAmountKey),
                getValue(item.item, this.dataAmountKey)
              )
            )
            // item.item[this.dataAmountKey] = calculateUtil.numberAdd(
            //   this.scanFormData[this.dataAmountKey],
            //   item.item[this.dataAmountKey]
            // )

            this.store?.dispatch?.('orderBackCountUtil', 'amountBack', item.item, {})
            self.tableData = this.rowToFrist(self.tableData, item.index)
            // 同步更新 taskData
            this.syncUpdateTaskData(self.tableData[0], false, self)
            this.setTreeExpand(self)
            return true
          }
        }
      }

      throw new Error(msg)
    },

    /**
     * @name 复核匹配模式-有源
     * @description 匹配到单据明细行，匹配并累加数量且数量不大于计划数量，如果未匹配成功则提示报错（不拆行）
     * @param {vue} self 指向组件 scanStandardPlus 的上下文
     *
     */
    modelReviewAmount(self, data) {
      let msg = '操作失败，超出上游单据商品范围'
      console.log(
        '匹配到单据明细行，匹配并累加数量且数量不大于计划数量，如果未匹配成功则提示报错（不拆行）'
      )
      console.log('填充到上表的 scanFormData: ', this.scanFormData)
      console.log('data: ', data)
      // 是否是编辑，只判断不执行修改
      let ifEdit = this.ifEdit(this.scanFormData, true, true, self, true)

      // 查找上表的任务
      let task = this.seachRows(true, self)
      // 校验是否超出上游单据商品范围
      if (!task || !task.size) throw new Error(msg)

      main: for (const [, val] of task) {
        const amoutAll = this.amountTotal(val, `item.${this.dataAmountKey}`)
        const planAll = this.amountTotal(val, `item.${this.dataPendingKey}`)
        const nowAmount = ifEdit
          ? this.scanFormData[this.dataAmountKey]
          : calculateUtil.numberAdd(amoutAll, this.scanFormData[this.dataAmountKey])

        child: for (let item of val) {
          const checkArr = this.setCheckArr()
          const ifSerial = scanUtils.ifSerial(
            this.scanFormData,
            `${this.dataGoodsInfoKey}.keepingSerial`
          )
          if (ifSerial) checkArr.push(`${this.dataGoodsKeepingKey}.serialNumber`)

          if (this.checkGoodAndBatchIsEq(item.item, this.scanFormData, checkArr)) {
            // 是否是编辑，会执行修改
            ifEdit = this.ifEdit(this.scanFormData, false, true, self)
            if (ifEdit) {
              if (ifEdit?.message) throw new Error(ifEdit?.message)
              return { msg: '修改成功' }
            }
            // 累加数量
            const amountRow = calculateUtil.numberAdd(
              getValue(item.item, this.dataAmountKey),
              getValue(this.scanFormData, this.dataAmountKey)
            )
            // const amountRow = calculateUtil.numberAdd(
            //   item.item[this.dataAmountKey],
            //   this.scanFormData[this.dataAmountKey]
            // )
            const planRow = getValue(item.item, `${this.dataPendingKey}`)

            console.log('amountRow: ', amountRow)
            console.log('planRow: ', planRow)
            // 所有主从行的数量之和（包括此次扫码的数量） 小于计划数量时，应该将所扫信息填入到该主从行中的某一行或拆行
            if (nowAmount > planAll) {
              msg = '操作失败，超出上游单据数量范围'
              continue main
            }
            // 校验每行的数量是否小于当前行的计划数量
            if (amountRow > planRow) {
              msg = '操作失败，超出上游单据数量范围'
              continue child
            }

            // 如果扫码获取到厂家原始条码，则将 originBarCode 和 originBarCodeDisplay 赋值到任务明细中
            this.setOriginBarCode(item.item)

            // 更新数量
            setValue(item.item, this.dataAmountKey, amountRow)
            // item.item[this.dataAmountKey] = amountRow

            this.store?.dispatch?.('orderBackCountUtil', 'amountBack', item.item, {})
            self.tableData = this.rowToFrist(self.tableData, item.index)
            // 同步更新 taskData
            this.syncUpdateTaskData(self.tableData[0], false, self)
            this.setTreeExpand(self)
            return true
          }
        }
      }

      throw new Error(msg)
    },
    /**
     * @name 匹配模式-无源
     * @description 通过所扫商品与任务明细进行匹配（字段：商品id、批号），匹配成功则累加数量，如果未匹配成功则提示报错（不拆行）
     * @param {vue} self 指向组件 scanStandardPlus 的上下文
     *
     */
    modelPassiveCheckoutAmountNoSplit(self) {
      let msg = this.nodataErrorMessage
      console.log(
        '通过所扫商品与任务明细进行匹配（字段：商品id、批号），匹配成功则累加数量，如果未匹配成功则提示报错（不拆行）'
      )
      console.log('填充到上表的 scanFormData: ', this.scanFormData)
      // 是否是编辑，只判断不执行修改
      let ifEdit = this.ifEdit(this.scanFormData, true, true, self, true)

      // 查找上表的任务
      let task = this.seachRows(false, self)
      // 校验是否超出上游单据商品范围
      if (!task || !task.size) throw new Error(msg)

      main: for (let [tIndex, _val] of task) {
        const val = Array.isArray(_val) ? _val : [{ index: tIndex, item: _val }]
        let amoutAll = this.amountTotal(val, `item.${this.dataAmountKey}`)
        let planAll = this.amountTotal(val, `item.${this.dataPendingKey}`)
        let nowAmount = ifEdit
          ? this.scanFormData[this.dataAmountKey]
          : calculateUtil.numberAdd(amoutAll, this.scanFormData[this.dataAmountKey])

        console.log('planAll: ', planAll)
        console.log('nowAmount: ', nowAmount)

        for (let item of val) {
          if (
            this.checkRowAndSelectBatchIsEq(
              item.item,
              this.scanFormData[this.dataGoodsKeepingKey]
            ) ||
            (this.$parent.currentSelected === 'epc' &&
              getValue(item.item, `${this.dataGoodsKeepingKey}.epc`) === this.scanResult.origin &&
              this.checkGoodsIsEq(item.item, this.scanFormData))
          ) {
            // 是否是编辑，会执行修改
            ifEdit = this.ifEdit(this.scanFormData, false, true, self)
            if (ifEdit) {
              if (ifEdit?.message) throw new Error(ifEdit?.message)
              return { msg: '修改成功' }
            }
            // 所有主从行的数量之和（包括此次扫码的数量） 小于计划数量时，应该将所扫信息填入到该主从行中的某一行或拆行
            if (nowAmount > planAll) {
              msg = this.amountErrorMessage
              continue main
            }

            // 如果扫码获取到厂家原始条码，则将 originBarCode 和 originBarCodeDisplay 赋值到任务明细中
            this.setOriginBarCode(item.item)

            // 累加数量
            setValue(
              item.item,
              this.dataAmountKey,
              calculateUtil.numberAdd(
                getValue(this.scanFormData, this.dataAmountKey),
                getValue(item.item, this.dataAmountKey)
              )
            )
            // item.item[this.dataAmountKey] = calculateUtil.numberAdd(
            //   this.scanFormData[this.dataAmountKey],
            //   item.item[this.dataAmountKey]
            // )

            this.store?.dispatch?.('orderBackCountUtil', 'amountBack', item.item, {})
            self.tableData = this.rowToFrist(self.tableData, item.index)
            // 同步更新 taskData
            this.syncUpdateTaskData(self.tableData[0], false, self)
            this.setTreeExpand(self)
            return true
          }
        }
      }

      throw new Error(msg)
    },
    // *********************************** 设置 Model END *********************************** //
  },
}
